(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(88011);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "$C": function() { return /* binding */ ModuleTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Pu": function() { return /* binding */ CenterOnSmallScreen; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 3rem 0;\n\n      ",
        " {\n        font-size: 24px;\n        margin-bottom: 3rem;\n        text-align: center;\n\n        &::after {\n          left: 50%;\n          bottom: -10px;\n          margin-left: -1.5rem;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background: ",
        ";\n  padding: 4rem 0 6rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 32px;\n  margin-bottom: 4rem;\n\n  && {\n    font-weight: normal;\n  }\n\n  &::after {\n    ",
        ";\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  justify-content: space-between;\n  line-height: 1;\n  font-size: 20px;\n  font-weight: normal !important;\n  margin-bottom: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n      text-align: center;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject1(), _colors__WEBPACK_IMPORTED_MODULE_1__.F1, _colors__WEBPACK_IMPORTED_MODULE_1__.M1, function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), Title);
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject2(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject3(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp("3rem", "10px"), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
var ModuleTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject5(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .flexVerticalCenter */ .VL(), function(props) {
    return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject4(), props.justify);
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6(), _colors__WEBPACK_IMPORTED_MODULE_1__.F2);
var CenterOnSmallScreen = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject8(), function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject7(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .centerBlock */ .EM());
});


/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 89501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TwoColumnsSection_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/twoColumnsSection.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Content = styled/* Content */.VY, Title = styled/* Title */.Dx;

var LeftPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        xs: {
            span: 24,
            order: props.$reverseOnSmallScreen ? 2 : 1
        },
        md: {
            span: 13,
            order: 1
        }
    };
})(_templateObject());
var RightPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        xs: {
            span: 24,
            order: props.$reverseOnSmallScreen ? 1 : 2
        },
        md: {
            span: 8,
            order: 2
        }
    };
})(_templateObject1());

;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/TwoColumnsSection.component.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var TwoColumnsSection = function(props) {
    var title = props.title, leftPanel = props.leftPanel, rightPanel = props.rightPanel, $reverseOnSmallScreen = props.$reverseOnSmallScreen, rest = _objectWithoutProperties(props, [
        "title",
        "leftPanel",
        "rightPanel",
        "$reverseOnSmallScreen"
    ]);
    var panelProps = {
        $reverseOnSmallScreen: $reverseOnSmallScreen
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, _objectSpread({}, rest, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPanel, _objectSpread({}, panelProps, {
                        children: leftPanel
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPanel, _objectSpread({}, panelProps, {
                        children: rightPanel
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ var TwoColumnsSection_component = (TwoColumnsSection);

;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/index.ts



/***/ }),

/***/ 35560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kk": function() { return /* binding */ ActionButton; },
  "W2": function() { return /* binding */ Container; },
  "U5": function() { return /* binding */ EmailInput; },
  "Hz": function() { return /* binding */ LegalCheckbox; },
  "rU": function() { return /* binding */ Link; },
  "ne": function() { return /* binding */ Slogan; },
  "ov": function() { return /* binding */ TermCaption; },
  "VZ": function() { return /* binding */ TwoColumns; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(79531);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(32808);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./src/layouts/twoColumnsSection/index.ts + 2 modules
var twoColumnsSection = __webpack_require__(89501);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/home/home.utils.js

var getImage = function(name) {
    return utils/* cdn.getImageUrl */.cK.getImageUrl("/images/home/".concat(name));
};

// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/home/subscription/subscription.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n      text-align: center;\n\n      ",
        " {\n        margin-bottom: 3rem;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    background-image: url(",
        ");\n    background-size: cover;\n    padding: 4rem 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n  font-size: 14px;\n  line-height: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: inherit;\n  font-size: inherit;\n  text-decoration: underline;\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          cursor: not-allowed;\n          opacity: 70%;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n  max-width: 350px;\n\n  && {\n    .ant-input-search-button {\n      ",
        ";\n      ",
        ";\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var TwoColumns = (0,styled_components_browser_esm/* default */.ZP)(twoColumnsSection/* default */.Z)(_templateObject1(), colors.F1, function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), mixins/* flexCenter */._7(), ActionButton);
});
var Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(_templateObject2(), getImage("subscription-background.svg"));
var Slogan = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var TermCaption = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var Link = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject5());
var ActionButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary",
    ghost: true
})(_templateObject6());
var EmailInput = (0,styled_components_browser_esm/* default */.ZP)(input/* default.Search */.Z.Search).attrs(function(props) {
    return {
        allowClear: true,
        size: "large",
        onSearch: !props.$submitDisabled && props.onSubmit
    };
})(_templateObject8(), function(props) {
    return props.$submitDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
}, mixins/* verticalLineMiddle */.XK("40px"));
var LegalCheckbox = (0,styled_components_browser_esm/* default */.ZP)(es_checkbox/* default */.Z)(_templateObject9());


/***/ }),

/***/ 88011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ index_page_N_SSP; },
  "default": function() { return /* reexport */ home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/layouts/twoColumnsSection/index.ts + 2 modules
var twoColumnsSection = __webpack_require__(89501);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
;// CONCATENATED MODULE: ./src/pages/home/activities/activities.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 3rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 2rem;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ModuleTitle = styled/* ModuleTitle */.$C, Section = styled/* Section */.$0;

var Container = (0,styled_components_browser_esm/* default */.ZP)(Section)(_templateObject());
var Module = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
var ActivitiesBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/home/activities/activity/activity.styled.js
function activity_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function activity_styled_templateObject() {
    var data = activity_styled_taggedTemplateLiteral([
        "\n  padding: 1rem 0;\n  border-bottom: 1px solid ",
        ";\n  margin: 0 !important;\n\n  h3 {\n    font-weight: normal;\n    margin-bottom: 0;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n\n    h3 {\n      color: ",
        ";\n    }\n  }\n\n  &:first-child {\n    padding-top: 0;\n  }\n"
    ]);
    activity_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function activity_styled_templateObject1() {
    var data = activity_styled_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  height: 150px;\n"
    ]);
    activity_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function activity_styled_templateObject2() {
    var data = activity_styled_taggedTemplateLiteral([
        "\n      padding-top: 1rem;\n    "
    ]);
    activity_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function activity_styled_templateObject3() {
    var data = activity_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    activity_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = activity_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 2rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = activity_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var activity_styled_ModuleTitle = styled/* ModuleTitle */.$C, Text = styled/* Text */.xv;

var activity_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs(function(props) {
    return {
        gutter: !props.$isSmallScreen && 64
    };
})(activity_styled_templateObject(), colors.T2, colors.B1, colors.B1);
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    xs: 24,
    md: 9
})(activity_styled_templateObject1());
var Content = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    xs: 24,
    md: 15
})(activity_styled_templateObject3(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(activity_styled_templateObject2());
});
var Metadata = (0,styled_components_browser_esm/* default */.ZP)(Text)(_templateObject4());
var Intro = (0,styled_components_browser_esm/* default */.ZP)(Text)(_templateObject5(), mixins/* lineClamp */.Sf(2));

// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/home/activities/activity/Activity.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Activity = function(param) {
    var title = param.title, image = param.image, link = param.link, location = param.location, type = param.type, date = param.date, intro = param.intro, isSmallScreen = param.isSmallScreen;
    var props = {
        $isSmallScreen: isSmallScreen
    };
    var imgProps = utils/* common.getStrapiImgProps */.y0.getStrapiImgProps(image);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(activity_styled_Container, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                    href: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        unoptimized: true,
                        alt: title,
                        src: imgProps.src,
                        layout: "fill",
                        objectFit: "cover"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
                    href: link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metadata, {
                            children: [
                                location,
                                type,
                                dayjs_min_default()(date).format("YYYY.MM.DD")
                            ].join(" | ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                            title: intro,
                            placement: "bottom",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {
                                children: intro
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Activity_component = (Activity);

;// CONCATENATED MODULE: ./src/pages/home/activities/activity/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/badge/index.js + 4 modules
var badge = __webpack_require__(63922);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CaretUpOutlined.js + 1 modules
var CaretUpOutlined = __webpack_require__(10010);
;// CONCATENATED MODULE: ./src/pages/home/activities/meetup/meetup.styled.js
function meetup_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function meetup_styled_templateObject() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  width: 36px;\n  padding-top: 6px;\n  margin-right: 1rem;\n  text-align: center;\n\n  svg {\n    visibility: hidden;\n  }\n"
    ]);
    meetup_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function meetup_styled_templateObject1() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  cursor: pointer;\n  padding: 1rem 0;\n  border-bottom: 1px solid ",
        ";\n\n  &:hover {\n    border-color: ",
        ";\n\n    ",
        " {\n      svg {\n        visibility: visible;\n      }\n    }\n  }\n"
    ]);
    meetup_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function meetup_styled_templateObject2() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  font-size: 14px;\n  color: ",
        ";\n  background: ",
        ";\n"
    ]);
    meetup_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function meetup_styled_templateObject3() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  height: 25px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #2d3758;\n  background: ",
        ";\n  position: relative;\n"
    ]);
    meetup_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function meetup_styled_templateObject4() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -2px;\n  right: -1px;\n  color: ",
        ";\n  transform: rotate(-45deg);\n  z-index: 2;\n\n  svg {\n    ",
        ";\n  }\n"
    ]);
    meetup_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function meetup_styled_templateObject5() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  transform: rotate(135deg);\n  bottom: -5px;\n  right: -5px;\n  z-index: 1;\n"
    ]);
    meetup_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = meetup_styled_taggedTemplateLiteral([
        "\n  flex: 1;\n\n  h3 {\n    font-size: 16px;\n    font-weight: normal;\n    margin-bottom: 0;\n  }\n\n  .ant-badge {\n    margin-left: 2rem;\n\n    &-status-text {\n      font-size: 12px;\n      color: ",
        ";\n    }\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var calendarGrey = "#b6b9c3";
var Calendar = styled_components_browser_esm/* default.div */.ZP.div(meetup_styled_templateObject());
var meetup_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(meetup_styled_templateObject1(), colors.T2, colors.B1, Calendar);
var CalendarHead = styled_components_browser_esm/* default.div */.ZP.div(meetup_styled_templateObject2(), mixins/* verticalLineMiddle */.XK("20px"), colors.M1, calendarGrey);
var CalendarBody = styled_components_browser_esm/* default.div */.ZP.div(meetup_styled_templateObject3(), mixins/* flexCenter */._7(), colors.M1);
var Arrow = (0,styled_components_browser_esm/* default */.ZP)(CaretUpOutlined/* default */.Z)(meetup_styled_templateObject4(), calendarGrey, mixins/* size */.dp("13px"));
var OppsiteArrow = (0,styled_components_browser_esm/* default */.ZP)(Arrow)(meetup_styled_templateObject5(), colors.M2);
var meetup_styled_Content = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6(), polished_esm/* rgba */.m4(colors.F1, 0.6));

;// CONCATENATED MODULE: ./src/pages/home/activities/meetup/Meetup.component.js







var Meetup = function(param) {
    var title = param.title, status = param.status, type = param.type, date = param.date, link = param.link;
    var dayObj = dayjs_min_default()(date);
    var month = dayObj.format("MMM");
    var day = dayObj.format("D");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(meetup_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Calendar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarHead, {
                            children: month
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBody, {
                            children: [
                                day,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OppsiteArrow, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(meetup_styled_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                status && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                                    color: colors.T3,
                                    text: status
                                }),
                                type && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                                    color: colors.T1,
                                    text: type
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Meetup_component = (Meetup);

;// CONCATENATED MODULE: ./src/pages/home/activities/meetup/index.js


;// CONCATENATED MODULE: ./src/pages/home/activities/Activities.component.js
function Activities_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Activities_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Activities_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Meetups = function(param) {
    var meetups = param.meetups;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: meetups.map(function(item, idx) {
            var props = Activities_component_objectSpread({
                key: idx
            }, item);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Meetup_component, Activities_component_objectSpread({}, props));
        })
    });
};
var Activities = function() {
    var data = (0,react.useContext)(context/* PageDataContext */.A6).data;
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
            title: "\u6D3B\u52A8",
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesBox, {
                isSmallScreen: isSmallScreen,
                children: data.activities.map(function(item) {
                    var props = Activities_component_objectSpread({
                        key: item.id
                    }, item, {
                        isSmallScreen: isSmallScreen
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Activity_component, Activities_component_objectSpread({}, props));
                })
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Module, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleTitle, {
                                children: [
                                    "Meetup \u76F8\u5173\u6D3B\u52A8\u4E13\u533A",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        href: "/events?category=meetup#all-events",
                                        children: "\u67E5\u770B\u5168\u90E8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meetups, {
                                meetups: data.meetups
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Module, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleTitle, {
                                children: [
                                    "\u5F00\u53D1\u8005\u6D3B\u52A8/\u7ADE\u8D5B\u4E13\u533A",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        href: "/events?category=\u5F00\u53D1\u8005\u6D3B\u52A8%2F\u7ADE\u8D5B#all-events",
                                        children: "\u67E5\u770B\u5168\u90E8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meetups, {
                                meetups: data.devActivities
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Activities_component = (Activities);

;// CONCATENATED MODULE: ./src/pages/home/activities/index.js


// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/GithubOutlined.js + 1 modules
var GithubOutlined = __webpack_require__(1210);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useMount/index.js
var useMount = __webpack_require__(78234);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
;// CONCATENATED MODULE: ./src/pages/home/banner/logo.svg
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349.744 64"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#000431",
    d: "M135.381 11.631h1.152v24.06h-1.152z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M0 11.97v23.94l20.733 11.97 20.733-11.97V11.97L20.733 0Z",
    fill: "#e30c34"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m20.72 7.992-13.77 7.95v7.948l6.887-3.976V35.92l6.884 3.969v-23.95l6.883-3.974Zm6.923 11.962V35.91l6.912-3.99V15.961Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M60.527 35.866h-4.913V16.08h-7.238v-4.094h19.126v4.094h-6.976ZM74.286 16.08h-4.59v-4.094h4.59Zm0 19.782h-4.59V18.176h4.59Zm5.038-23.876h9.334c3.668 0 5.928.819 7.533 2.751a15.882 15.882 0 0 1 0 18.34c-1.6 1.932-3.9 2.784-7.533 2.784h-9.334Zm9.334 19.781c3.7 0 5.535-2.587 5.535-7.827 0-5.273-1.834-7.86-5.535-7.86h-4.422v15.686Zm25.468 4.099h-10.742v-23.88h10.644c6.288 0 7.795 4.094 7.795 6.288 0 2.03-.917 3.406-3.275 4.913 2.686 1.572 3.963 3.439 3.963 5.8-.001 2.846-1.671 6.879-8.385 6.879Zm-5.83-14.378h5.338c2.26 0 3.471-.95 3.471-2.686 0-1.769-1.212-2.718-3.471-2.718h-5.337Zm0 10.284h5.862c2.391 0 3.635-1.081 3.635-3.079 0-2.03-1.244-3.111-3.635-3.111h-5.861ZM163.793 19.261c-.164-2.42-1.9-3.729-5-3.729-2.519 0-4.121 1.145-4.121 2.944 0 1.734 1.014 2.421 4.514 3.108l3.729.72c4.416.85 6.313 2.813 6.313 6.574 0 4.841-3.631 7.72-9.78 7.72-6.084 0-9.584-2.78-9.878-7.883h4.776c.164 2.551 2.028 3.958 5.364 3.958 2.977 0 4.809-1.211 4.809-3.206 0-1.93-1.21-2.846-4.481-3.467l-3.336-.654c-4.841-.916-6.705-2.715-6.705-6.411 0-4.645 3.3-7.327 9.028-7.327 3.7 0 9.355 1.145 9.355 7.654Zm31.006 4.776a14.012 14.012 0 0 1-2.617 8.439l2.617 2.486-2.486 2.65-2.813-2.65a11.139 11.139 0 0 1-6.182 1.636c-7 0-11.481-5.3-11.481-12.5s4.481-12.5 11.481-12.5c7.098.009 11.481 5.439 11.481 12.439Zm-5.986 5.266a11.572 11.572 0 0 0 1.08-5.168c0-5.07-2.584-8.341-6.575-8.341-3.958 0-6.575 3.3-6.575 8.308s2.617 8.308 6.542 8.308a6.552 6.552 0 0 0 2.879-.621l-2.514-2.388 2.486-2.649Zm14.818 2.453h11.416v4.089h-16.322V11.999h4.906Zm23.125-.458c0-3.173 1.7-4.972 5.2-5.561l1.832-.327c1.5-.229 3.663-.327 3.663-2.061q0-1.766-2.65-1.766c-2.257 0-3.009.589-3.238 2.42h-4.416c.295-4.089 2.781-6.117 7.556-6.117s7.229 1.832 7.229 5.43v9.818a2.52 2.52 0 0 0 1.047 2.159v.556h-4.973a2.254 2.254 0 0 1-.524-1.766 7.336 7.336 0 0 1-5.364 2.519 5.048 5.048 0 0 1-5.362-5.304Zm10.7-3.795a5.747 5.747 0 0 1-1.93.556l-1.57.294c-1.9.393-2.617 1.047-2.617 2.421 0 1.309.949 2.126 2.486 2.126 2.322 0 3.631-1.5 3.631-4.154Zm16.576-5.92h-2.551v9.614c0 1.57.294 1.93 1.5 1.93a6.887 6.887 0 0 0 1.047-.1v3.206a8.382 8.382 0 0 1-2.65.36c-3.009 0-4.481-1.374-4.481-4.154v-10.86h-2.257v-3.042h2.257v-4.74h4.58v4.743h2.551Zm25.616-2.322c-.164-2.42-1.9-3.729-5-3.729-2.519 0-4.121 1.145-4.121 2.944 0 1.734 1.014 2.421 4.514 3.108l3.729.72c4.416.85 6.313 2.813 6.313 6.574 0 4.841-3.631 7.72-9.78 7.72-6.084 0-9.584-2.78-9.879-7.883h4.776c.164 2.551 2.028 3.958 5.365 3.958 2.977 0 4.808-1.211 4.808-3.206 0-1.93-1.21-2.846-4.481-3.467l-3.336-.654c-4.841-.916-6.706-2.715-6.706-6.411 0-4.645 3.3-7.327 9.028-7.327 3.7 0 9.355 1.145 9.355 7.654Zm12.626 8.112c0 3.434 1.407 5.528 3.729 5.528 1.766 0 2.682-.883 3.271-3.173h4.383a7.267 7.267 0 0 1-7.687 6.869c-5.234 0-8.275-3.4-8.275-9.224 0-6.019 3.075-9.486 8.341-9.486 4.416 0 7.294 2.584 7.621 6.9h-4.383c-.523-2.323-1.406-3.206-3.271-3.206-3.173.002-3.729 3.338-3.729 5.792Zm13.672 3.925c0-3.173 1.7-4.972 5.2-5.561l1.832-.327c1.5-.229 3.664-.327 3.664-2.061q0-1.766-2.65-1.766c-2.257 0-3.009.589-3.238 2.42h-4.416c.295-4.089 2.78-6.117 7.556-6.117s7.229 1.832 7.229 5.43v9.818a2.52 2.52 0 0 0 1.047 2.159v.556h-4.972a2.254 2.254 0 0 1-.523-1.766 7.337 7.337 0 0 1-5.365 2.519 5.048 5.048 0 0 1-5.364-5.304Zm10.7-3.795a5.75 5.75 0 0 1-1.93.556l-1.57.294c-1.9.393-2.617 1.047-2.617 2.421 0 1.309.949 2.126 2.486 2.126 2.322 0 3.631-1.5 3.631-4.154Zm13.212 8.342h-4.58V11.999h4.58Zm19.886-8.178a7.791 7.791 0 0 1-.033.785h-11.842c.1 2.388.589 4.645 3.664 4.645a3.546 3.546 0 0 0 3.5-2.224h4.514a8.177 8.177 0 0 1-8.178 5.724c-5 0-8.079-3.467-8.079-9.126 0-5.921 3.107-9.584 8.178-9.584 3.533 0 8.276 1.963 8.276 9.78Zm-8.341-6.28c-2.028 0-3.173 1.341-3.467 4.023h7.033c-.2-2.584-1.44-4.023-3.566-4.023Z",
    fill: "#000431"
  })));
};
/* harmony default export */ var logo = (SvgLogo);
;// CONCATENATED MODULE: ./src/pages/home/banner/banner.styled.js
function banner_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function banner_styled_templateObject() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    background: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    banner_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function banner_styled_templateObject1() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n      padding: 0 0 5.5rem;\n\n      ",
        " {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        > * {\n          display: block;\n        }\n\n        p {\n          text-align: center;\n        }\n\n        .ant-btn-primary {\n          margin-bottom: 2rem;\n        }\n      }\n\n      ",
        " {\n        width: 80%;\n        text-align: center;\n      }\n    "
    ]);
    banner_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function banner_styled_templateObject2() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 5rem 1rem 7.5rem;\n\n  ",
        "\n"
    ]);
    banner_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function banner_styled_templateObject3() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  height: 250px;\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n\n  & > * {\n    flex: 1;\n  }\n"
    ]);
    banner_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function banner_styled_templateObject4() {
    var data = banner_styled_taggedTemplateLiteral([
        ""
    ]);
    banner_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function banner_styled_templateObject5() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  min-height: 3rem;\n  max-width: 350px;\n"
    ]);
    banner_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function banner_styled_templateObject6() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  && {\n    ",
        ";\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: normal;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    banner_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  padding: 0 2rem !important;\n\n  span {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  background: linear-gradient(top to bottom, ",
        ", ",
        ");\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  display: inline-block;\n  border-radius: 4px;\n  font-weight: bold;\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif;\n  cursor: pointer;\n\n  .anticon {\n    font-size: 16px;\n    margin-right: 5px;\n  }\n\n  &,\n  .ant-tooltip-inner {\n    ",
        ";\n    font-size: 14px;\n    color: ",
        ";\n    min-height: auto;\n    padding: 0 8px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  right: 6px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  z-index: 10;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  height: 40px;\n  border-right: 1px solid ",
        ";\n  cursor: pointer;\n\n  &:last-child {\n    border-right: none;\n  }\n\n  svg {\n    height: 40px;\n    margin-right: 40px;\n  }\n\n  span {\n    font-size: 18px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n      padding: 12px 0;\n\n      ",
        " {\n        height: 66px;\n        flex-direction: column;\n        border-right: none;\n\n        svg {\n          height: 30px;\n          margin-right: 0;\n          margin-bottom: 12px;\n        }\n\n        span {\n          font-size: 14px;\n          line-height: 1;\n        }\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  background: ",
        ";\n  position: absolute;\n  bottom: -45px;\n  left: 0;\n  right: 0;\n  padding: 25px 0;\n  margin: 0 16px;\n  border-radius: 10px;\n  border: 1px solid ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  height: ",
        ";\n  background: ",
        ";\n  background-size: cover;\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  background-color: rgb(0, 0, 0, 0.4);\n  padding: 0 1rem;\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n      margin-bottom: 3rem;\n\n      .slick-slide {\n        padding-right: 0;\n      }\n\n      .slick-dots {\n        margin: 0 auto;\n        bottom: -32px;\n\n        li {\n          margin: 3px 8px;\n\n          &,\n          button {\n            ",
        "\n          }\n\n          &.slick-active {\n            &,\n            button {\n              ",
        "\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = banner_styled_taggedTemplateLiteral([
        "\n  .slick-slide {\n    padding-right: 2.5rem;\n    cursor: pointer;\n    height: ",
        "px !important;\n  }\n\n  .slick-track {\n    height: auto !important;\n  }\n\n  .slick-dots {\n    li {\n      margin: 8px 3px;\n\n      &,\n      button {\n        ",
        "\n        background: ",
        ";\n        border-radius: 3px;\n      }\n\n      &.slick-active {\n        &,\n        button {\n          ",
        "\n          background: ",
        ";\n        }\n      }\n    }\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






var githubBlack = "#24292e";
var banner_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(banner_styled_templateObject(), colors.M1, colors.B4);
var banner_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(banner_styled_templateObject2(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(banner_styled_templateObject1(), LeftPanel, banner_styled_Intro);
});
var LeftPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    xs: {
        order: 2
    },
    sm: {
        order: 2
    },
    md: {
        order: 1,
        span: 10
    },
    lg: {
        order: 1,
        span: 8
    }
})(banner_styled_templateObject3());
var RightPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    xs: {
        order: 1,
        span: 24
    },
    sm: {
        order: 1,
        span: 24
    },
    md: {
        order: 2,
        span: 14
    },
    lg: {
        order: 2,
        span: 16
    }
})(banner_styled_templateObject4());
var Logo = (0,styled_components_browser_esm/* default */.ZP)(logo)(banner_styled_templateObject5());
var banner_styled_Intro = styled_components_browser_esm/* default.h2 */.ZP.h2(banner_styled_templateObject6(), mixins/* reset */.mc(), colors.F1);
var TryButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary",
    size: "large"
})(_templateObject7());
var StarButton = styled_components_browser_esm/* default.span */.ZP.span(_templateObject8(), colors.M1, colors.M2, mixins/* verticalLineMiddle */.XK("26px"), githubBlack);
var TooltipContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9());
var StarButtonTooltip = (0,styled_components_browser_esm/* default */.ZP)(tooltip/* default */.Z).attrs({
    visible: true,
    color: colors.M2
})(_templateObject10());
var NavItem = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject11(), mixins/* flexCenter */._7(), colors.T2, colors.F1);
var Navs = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    justify: "center",
    align: "middle"
})(_templateObject13(), mixins/* boxShadow */.Wn(), colors.M1, colors.T2, function(props) {
    return props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), NavItem);
});
var Promotion = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14(), function(props) {
    return "".concat(props.height, "px");
}, function(props) {
    return "url(".concat(props.image, ") center center no-repeat");
});
var PromotionOverlay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject15(), mixins/* lineClamp */.Sf(), mixins/* verticalLineMiddle */.XK("50px"), colors.M1);
var Carousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).attrs(function(props) {
    return {
        dotPosition: props.isSmallScreen ? "bottom" : "right",
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 3000
    };
})(_templateObject17(), function(param) {
    var height = param.height;
    return height;
}, mixins/* size */.dp("6px", "40px"), polished_esm/* rgba */.m4(colors.F2, 0.1), mixins/* size */.dp("6px", "50px"), polished_esm/* rgba */.m4(colors.F2, 0.3), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), mixins/* size */.dp("40px", "6px"), mixins/* size */.dp("50px", "6px"));
});

;// CONCATENATED MODULE: ./src/pages/home/banner/activity.svg
var _style, activity_path, activity_path2, _g;
function activity_extends() { activity_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return activity_extends.apply(this, arguments); }

var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/react.createElement("svg", activity_extends({
    id: "activity_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".activity_svg__st2{fill:#172d72}.activity_svg__st3{fill:#be1d32}")), /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5973",
    transform: "translate(-1269 -522)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5972",
    transform: "translate(1269 522)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_5295",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5254",
    transform: "translate(1276.875 534.25)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4461",
    style: {
      fill: "#e2e5ee"
    },
    d: "M0 4h40v27.9H0z"
  }), activity_path || (activity_path = /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4462",
    className: "activity_svg__st2",
    d: "M0 0h40v4H0z"
  })), activity_path2 || (activity_path2 = /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u8DEF\\u5F84_15813",
    className: "activity_svg__st2",
    d: "M40 22.6h-9.4V32l9.4-9.4z"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5253",
    transform: "translate(5.505 7.565)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5250"
  }, /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4463",
    className: "activity_svg__st3",
    d: "M0 0h4.1v4.1H0z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4464",
    className: "activity_svg__st3",
    d: "M8.3 0h4.1v4.1H8.3z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4465",
    className: "activity_svg__st3",
    d: "M16.6 0h4.1v4.1h-4.1z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4466",
    className: "activity_svg__st3",
    d: "M24.8 0h4.1v4.1h-4.1z"
  })), /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5251",
    transform: "translate(0 16.234)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4467",
    className: "activity_svg__st3",
    d: "M0 0h4.1v4.1H0z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4468",
    className: "activity_svg__st3",
    d: "M8.3 0h4.1v4.1H8.3z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4469",
    className: "activity_svg__st3",
    d: "M16.6 0h4.1v4.1h-4.1z"
  })), /*#__PURE__*/react.createElement("g", {
    id: "activity_svg__\\u7EC4_5252",
    transform: "translate(0 8.118)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4470",
    className: "activity_svg__st3",
    d: "M0 0h4.1v4.1H0z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4471",
    className: "activity_svg__st3",
    d: "M8.3 0h4.1v4.1H8.3z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4472",
    className: "activity_svg__st3",
    d: "M16.6 0h4.1v4.1h-4.1z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4473",
    className: "activity_svg__st3",
    d: "M24.8 0h4.1v4.1h-4.1z"
  })))))));
};
/* harmony default export */ var activity = (SvgActivity);
;// CONCATENATED MODULE: ./src/pages/home/banner/article.svg
var article_style, article_g, article_path, article_path2, article_path3, _circle, article_path4, _path5;
function article_extends() { article_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return article_extends.apply(this, arguments); }

var SvgArticle = function SvgArticle(props) {
  return /*#__PURE__*/react.createElement("svg", article_extends({
    id: "article_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), article_style || (article_style = /*#__PURE__*/react.createElement("style", null, ".article_svg__st0{fill:none}.article_svg__st2{fill:#172d72}.article_svg__st3{fill:#be1d32}")), /*#__PURE__*/react.createElement("g", {
    id: "article_svg__\\u7EC4_5977",
    transform: "translate(-83.562 -132.128)"
  }, article_g || (article_g = /*#__PURE__*/react.createElement("g", {
    id: "article_svg__\\u7EC4_5963",
    transform: "translate(83.562 132.128)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5289",
    className: "article_svg__st0",
    d: "M0 0h56v56H0z"
  }))), /*#__PURE__*/react.createElement("g", {
    id: "article_svg__\\u7EC4_5966",
    transform: "translate(95.635 140.142)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "article_svg__\\u7EC4_5964"
  }, /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u8DEF\\u5F84_17291",
    d: "M24 0H0v40h32V8l-8-8z",
    style: {
      fill: "#e2e5ee"
    }
  })), article_path || (article_path = /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5290",
    className: "article_svg__st2",
    d: "M4 7.9h10.1v4H4z"
  })), article_path2 || (article_path2 = /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5291",
    className: "article_svg__st2",
    d: "M4 15.9h20v4H4z"
  })), article_path3 || (article_path3 = /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5292",
    className: "article_svg__st3",
    d: "M4 24h10.1v4H4z"
  })), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    id: "article_svg__\\u692D\\u5706_1333",
    className: "article_svg__st3",
    cx: 22,
    cy: 26,
    r: 2.1
  })), article_path4 || (article_path4 = /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u8DEF\\u5F84_17292",
    className: "article_svg__st2",
    d: "m24 0 8 8h-8V0z"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    id: "article_svg__\\u76F4\\u7EBF_390",
    className: "article_svg__st0",
    d: "m24 0 8 8"
  })))));
};
/* harmony default export */ var article = (SvgArticle);
;// CONCATENATED MODULE: ./src/pages/home/banner/asktug.svg
var asktug_style, asktug_path, asktug_g;
function asktug_extends() { asktug_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return asktug_extends.apply(this, arguments); }

var SvgAsktug = function SvgAsktug(props) {
  return /*#__PURE__*/react.createElement("svg", asktug_extends({
    id: "asktug_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), asktug_style || (asktug_style = /*#__PURE__*/react.createElement("style", null, ".asktug_svg__st0{fill:#e8eaf1}")), /*#__PURE__*/react.createElement("g", {
    id: "asktug_svg__\\u7EC4_5976",
    transform: "translate(-309 -520)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "asktug_svg__\\u7EC4_5497",
    transform: "translate(321 528)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "asktug_svg__\\u7EC4_5257"
  }, asktug_path || (asktug_path = /*#__PURE__*/react.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15814",
    className: "asktug_svg__st0",
    d: "M29.4 19.6c4.2-5.1 3.5-12.6-1.5-16.8-4.8-4-11.9-3.6-16.2.8l-8.1 8.1 3 3L8.3 13c.6 6.1 5.7 10.9 11.9 10.9h.2l-.2 5L28 21c.5-.4.9-.8 1.3-1.3l.1-.1z"
  })), /*#__PURE__*/react.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15815",
    d: "M28 16.1c0-6.6-5.3-11.9-11.9-11.9-3.2 0-6.3 1.3-8.6 3.6l-3.9 4 1 1c-1.8 6.3 1.8 12.9 8.2 14.8 2.5.7 5.1.6 7.5-.3v1.5l3.9-3.9c2.4-2.3 3.8-5.5 3.8-8.8z",
    style: {
      fill: "#be1d32"
    }
  }), /*#__PURE__*/react.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15816",
    d: "M23.9 20.2c0-6.6-5.3-11.9-11.9-11.9S0 13.6 0 20.2c0 5.5 3.7 10.2 9 11.6V40l10.8-10.8c2.6-2.2 4.1-5.5 4.1-9z",
    style: {
      fill: "#172d72"
    }
  }), asktug_g || (asktug_g = /*#__PURE__*/react.createElement("g", {
    id: "asktug_svg__\\u7EC4_5256",
    transform: "translate(5.65 12.967)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15817",
    className: "asktug_svg__st0",
    d: "M6.3 0 0 3.6v3.6l3.1-1.8v7.3l3.1 1.8V3.6l3.1-1.8-3-1.8z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15818",
    className: "asktug_svg__st0",
    d: "M9.4 5.4v7.3l3.1-1.8V3.6L9.4 5.4z"
  }))))), /*#__PURE__*/react.createElement("g", {
    id: "asktug_svg__\\u7EC4_5963",
    transform: "translate(309 520)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "asktug_svg__\\u77E9\\u5F62_5289",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }))));
};
/* harmony default export */ var asktug = (SvgAsktug);
;// CONCATENATED MODULE: ./src/pages/home/banner/doc.svg
var doc_style, doc_path, doc_circle;
function doc_extends() { doc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return doc_extends.apply(this, arguments); }

var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/react.createElement("svg", doc_extends({
    id: "doc_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), doc_style || (doc_style = /*#__PURE__*/react.createElement("style", null, ".doc_svg__st3{fill:#172d72}")), /*#__PURE__*/react.createElement("g", {
    id: "doc_svg__\\u7EC4_5974",
    transform: "translate(-243.383 -132.268)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "doc_svg__\\u7EC4_5968",
    transform: "translate(243.383 132.268)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "doc_svg__\\u77E9\\u5F62_5293",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/react.createElement("g", {
    id: "doc_svg__\\u7EC4_5970",
    transform: "translate(253.456 140.028)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "doc_svg__\\u7EC4_5969",
    transform: "translate(3.779)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "doc_svg__\\u8DEF\\u5F84_17293",
    d: "M28 8v26.9H0V0h19.9L28 8z",
    style: {
      fill: "#be1d32"
    }
  })), /*#__PURE__*/react.createElement("path", {
    id: "doc_svg__\\u8DEF\\u5F84_17294",
    d: "M36 24v16H0V16h28l8 8z",
    style: {
      fill: "#e2e5ee"
    }
  }), doc_path || (doc_path = /*#__PURE__*/react.createElement("path", {
    id: "doc_svg__\\u77E9\\u5F62_5294",
    className: "doc_svg__st3",
    d: "M6 20h16v4H6z"
  })), doc_circle || (doc_circle = /*#__PURE__*/react.createElement("circle", {
    id: "doc_svg__\\u692D\\u5706_1334",
    className: "doc_svg__st3",
    cx: 8,
    cy: 30,
    r: 2
  })))));
};
/* harmony default export */ var doc = (SvgDoc);
;// CONCATENATED MODULE: ./src/pages/home/banner/Banner.component.js
function Banner_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Banner_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Banner_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var navItems = [
    {
        icon: doc,
        langKey: "doc",
        label: "\u6587\u6863\u624B\u518C",
        link: "https://docs.pingcap.com/zh"
    },
    {
        icon: asktug,
        langKey: "asktug",
        label: "\u95EE\u7B54",
        link: "https://pingkai.cn/tidbcommunity/forum/"
    },
    {
        icon: article,
        langKey: "article",
        label: "\u6587\u7AE0",
        link: "/blog"
    },
    {
        icon: activity,
        langKey: "activity",
        label: "\u6D3B\u52A8",
        link: "/events"
    }, 
];
var Banner = function() {
    var tooltipContainerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var data = (0,react.useContext)(context/* PageDataContext */.A6).data;
    var ref1 = (0,useIsSmallScreen/* default */.Z)(), isSmallScreen = ref1.isSmallScreen, breakpoint = ref1.breakpoint;
    // Solving the warning of "Expected server HTML to contain a matching <tag>"
    // because of AntD Tooltip.
    // More details: https://github.com/vercel/next.js/discussions/17443
    (0,useMount/* default */.Z)(function() {
        setMounted(true);
    });
    var tooltipProps = {
        title: new Intl.NumberFormat("en-US").format(data.githubInfo.starNum),
        placement: "right",
        autoAdjustOverflow: false,
        getPopupContainer: function() {
            return tooltipContainerRef === null || tooltipContainerRef === void 0 ? void 0 : tooltipContainerRef.current;
        }
    };
    var height = function() {
        if (breakpoint.lg) {
            return 250;
        }
        if (breakpoint.md) {
            return 200;
        }
        if (breakpoint.sm) {
            return 250;
        }
        if (breakpoint.xs) {
            return 200;
        }
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(banner_styled_Content, {
            isSmallScreen: isSmallScreen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    gutter: !isSmallScreen && [
                        32,
                        64
                    ],
                    justify: isSmallScreen ? "center" : "space-between",
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftPanel, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_styled_Intro, {
                                    children: "TiDB \u662F\u4E00\u6B3E\u540C\u65F6\u652F\u6301\u5728\u7EBF\u4E8B\u52A1\u5904\u7406\u4E0E\u5728\u7EBF\u5206\u6790\u5904\u7406 (HTAP) \u7684\u878D\u5408\u578B\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u4EA7\u54C1\u3002"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    gutter: 32,
                                    justify: isSmallScreen ? "space-around" : "space-between",
                                    align: "bottom",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            flex: "none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "https://github.com/pingcap/tidb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TryButton, {
                                                    children: "\u7ACB\u5373\u4F53\u9A8C"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            flex: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "https://github.com/pingcap/tidb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StarButton, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GithubOutlined/* default */.Z, {}),
                                                        "Star",
                                                        mounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(StarButtonTooltip, Banner_component_objectSpread({}, tooltipProps, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContainer, {
                                                                ref: tooltipContainerRef
                                                            })
                                                        }))
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPanel, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                                isSmallScreen: isSmallScreen,
                                height: height,
                                children: data.promotions.map(function(param) {
                                    var id = param.id, title = param.title, link = param.link, image = param.image;
                                    var imgProps = utils/* common.getStrapiImgProps */.y0.getStrapiImgProps(image);
                                    var props = {
                                        title: title,
                                        link: link,
                                        image: imgProps.src,
                                        height: height
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promotion, Banner_component_objectSpread({}, props, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionOverlay, {
                                                children: title
                                            })
                                        }))
                                    }, id);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navs, {
                    $isSmallScreen: isSmallScreen,
                    children: navItems.map(function(param) {
                        var Icon = param.icon, label = param.label, link = param.link;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, {
                                href: link,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: label
                                    })
                                ]
                            })
                        }, label);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banner_component = (Banner);

;// CONCATENATED MODULE: ./src/pages/home/banner/index.js


// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EditFilled.js + 1 modules
var EditFilled = __webpack_require__(36531);
;// CONCATENATED MODULE: ./src/pages/home/forum/categories/categories.styled.js
function categories_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function categories_styled_templateObject() {
    var data = categories_styled_taggedTemplateLiteral([
        "\n  margin-right: -1rem;\n  margin-bottom: -1rem;\n"
    ]);
    categories_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function categories_styled_templateObject1() {
    var data = categories_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  text-decoration: none;\n  font-size: 14px;\n  color: ",
        ";\n  background: ",
        ";\n  border-radius: 4px;\n  padding: 0 8px;\n  margin-right: 1rem;\n  margin-bottom: 1rem;\n  display: inline-block;\n  border: 1px solid ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    categories_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var categories_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(categories_styled_templateObject());
var Tag = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(categories_styled_templateObject1(), mixins/* verticalLineMiddle */.XK("36px"), colors.F2, colors.M1, colors.T2, colors.M1, colors.B1, colors.B1);

;// CONCATENATED MODULE: ./src/pages/home/forum/categories/Categories.component.js



var Categories = function(param1) {
    var categories = param1.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_styled_Container, {
        children: categories.map(function(param) {
            var name = param.name, link = param.link;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                href: link,
                children: name
            }, name);
        })
    });
};
/* harmony default export */ var Categories_component = (Categories);

;// CONCATENATED MODULE: ./src/pages/home/forum/categories/index.js


;// CONCATENATED MODULE: ./src/pages/home/forum/asktug.svg
var forum_asktug_path, asktug_path2, asktug_path3, asktug_path4, asktug_path5;
function forum_asktug_extends() { forum_asktug_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return forum_asktug_extends.apply(this, arguments); }

var asktug_SvgAsktug = function SvgAsktug(props) {
  return /*#__PURE__*/react.createElement("svg", forum_asktug_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.464 29.358"
  }, props), forum_asktug_path || (forum_asktug_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.573 14.369A8.76 8.76 0 0 0 8.567 2.654L2.615 8.621l2.222 2.222 1.288-1.291a8.76 8.76 0 0 0 8.723 7.966h.123l-.176 3.674 5.764-5.79a8.83 8.83 0 0 0 .954-.958l.067-.067z",
    fill: "#00aeef"
  })), asktug_path2 || (asktug_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M20.553 11.808A8.76 8.76 0 0 0 5.498 5.719l-2.887 2.9.764.764a8.764 8.764 0 0 0 11.51 10.621l.014 1.085 2.847-2.858a8.736 8.736 0 0 0 2.807-6.423z",
    fill: "#3351ff"
  })), asktug_path3 || (asktug_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M17.518 14.847A8.76 8.76 0 0 0 .12 13.401a8.76 8.76 0 0 0 6.479 9.936v6.021l7.893-7.893a8.74 8.74 0 0 0 3.026-6.618z",
    fill: "#172d72"
  })), asktug_path4 || (asktug_path4 = /*#__PURE__*/react.createElement("path", {
    d: "m8.749 9.517-4.6 2.656v2.656l2.3-1.329v5.348l2.3 1.326v-8l2.3-1.328zm2.313 3.997v5.332l2.31-1.333V12.18z",
    fill: "#fff"
  })), asktug_path5 || (asktug_path5 = /*#__PURE__*/react.createElement("path", {
    d: "m28.963 18.644-.842 2.526h-2.629l4.45-12.525h2.852l4.329 12.525h-2.644l-.825-2.526zm2.354-7.044-1.632 4.9h3.264zm10.739 8.075c1.117 0 1.787-.344 1.787-.911 0-.378-.206-.567-.808-.756l-2.869-.893a2.29 2.29 0 0 1-2.027-2.285c0-1.907 1.46-3.092 3.814-3.092 2.491 0 4 1.185 4.037 3.144h-2.319c-.017-.842-.584-1.254-1.735-1.254-.842 0-1.392.344-1.392.859 0 .378.172.515.842.721l3.041.876a2.254 2.254 0 0 1 1.821 2.338c0 1.289-.807 3.144-4.054 3.144-2.818 0-4.312-1.065-4.381-3.093h2.354c.136.636.381 1.202 1.889 1.202zm11.356-7.783h2.732l-3.162 3.5 3.385 5.773h-2.818l-2.216-4.089-.962 1.048v3.041h-2.405V8.645h2.405V15.5zm10.017 9.278h-2.578V10.793h-3.8V8.645h10.034v2.148h-3.66zm5.546-4.038V8.645h2.577v8.487c0 1.512.773 2.234 2.388 2.234s2.388-.722 2.388-2.234V8.645h2.577v8.487c0 3.539-2.852 4.433-4.965 4.433s-4.965-.893-4.965-4.433zm18.078-6.528c-2.182 0-3.5 1.632-3.5 4.33 0 2.577 1.495 4.4 3.574 4.4a3.172 3.172 0 0 0 3.178-2.783h-2.852v-2.154h5.017v6.769h-1.546l-.309-1.649a4.16 4.16 0 0 1-3.78 2.01c-3.385 0-5.859-2.766-5.859-6.563 0-3.9 2.457-6.563 6.065-6.563 3.024 0 5.12 1.632 5.429 4.209h-2.423a2.86 2.86 0 0 0-2.994-2.006z",
    fill: "#172d72"
  })));
};
/* harmony default export */ var forum_asktug = (asktug_SvgAsktug);
;// CONCATENATED MODULE: ./src/pages/home/forum/forum.styled.js
function forum_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function forum_styled_templateObject() {
    var data = forum_styled_taggedTemplateLiteral([
        "\n  && {\n    background: ",
        ";\n  }\n"
    ]);
    forum_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function forum_styled_templateObject1() {
    var data = forum_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    forum_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function forum_styled_templateObject2() {
    var data = forum_styled_taggedTemplateLiteral([
        "\n  padding: 2rem 0 1.5rem;\n  border-bottom: 1px solid ",
        ";\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  p {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    forum_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function forum_styled_templateObject3() {
    var data = forum_styled_taggedTemplateLiteral([
        "\n  height: 29.5px;\n  margin-right: 1rem;\n  position: relative;\n  top: 8px;\n"
    ]);
    forum_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function forum_styled_templateObject4() {
    var data = forum_styled_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  text-decoration: underline;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    forum_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var forum_styled_ModuleTitle = styled/* ModuleTitle */.$C, forum_styled_Section = styled/* Section */.$0, CenterOnSmallScreen = styled/* CenterOnSmallScreen */.Pu;

var forum_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(forum_styled_Section)(forum_styled_templateObject(), colors.M1);
var Posts = styled_components_browser_esm/* default.div */.ZP.div(forum_styled_templateObject1());
var forum_styled_Module = styled_components_browser_esm/* default.div */.ZP.div(forum_styled_templateObject2(), colors.T2);
var AsktugLogo = (0,styled_components_browser_esm/* default */.ZP)(forum_asktug)(forum_styled_templateObject3());
var Link = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(forum_styled_templateObject4(), colors.B1);

;// CONCATENATED MODULE: ./src/pages/home/blogs/blogs.styled.js
function blogs_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function blogs_styled_templateObject() {
    var data = blogs_styled_taggedTemplateLiteral([
        "\n  background: ",
        ";\n"
    ]);
    blogs_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function blogs_styled_templateObject1() {
    var data = blogs_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    blogs_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var blogs_styled_ModuleTitle = styled/* ModuleTitle */.$C, blogs_styled_Section = styled/* Section */.$0, blogs_styled_CenterOnSmallScreen = styled/* CenterOnSmallScreen */.Pu;

var blogs_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(blogs_styled_Section)(blogs_styled_templateObject(), colors.M2);
var Blogs = styled_components_browser_esm/* default.div */.ZP.div(blogs_styled_templateObject1());

;// CONCATENATED MODULE: ./src/pages/home/forum/post/post.styled.js
function post_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function post_styled_templateObject() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    post_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function post_styled_templateObject1() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  padding: 1rem 0;\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n\n  h3 {\n    ",
        ";\n    font-size: 18px;\n    font-weight: normal !important;\n    margin-bottom: 1rem;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n\n    h3 {\n      color: ",
        ";\n    }\n  }\n\n  &:first-child {\n    padding-top: 0;\n  }\n"
    ]);
    post_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function post_styled_templateObject2() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  display: flex;\n\n  > span {\n    ",
        ";\n    width: 115px;\n    text-align: right;\n  }\n"
    ]);
    post_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function post_styled_templateObject3() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  align-items: flex-start;\n\n  h3 {\n    flex: 1;\n  }\n"
    ]);
    post_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function post_styled_templateObject4() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  align-items: flex-end;\n\n  > div {\n    ",
        ";\n    flex: 1;\n  }\n"
    ]);
    post_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function post_styled_templateObject5() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  img {\n    ",
        ";\n    border-radius: 50%;\n    margin-right: 6px;\n  }\n"
    ]);
    post_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function post_styled_templateObject6() {
    var data = post_styled_taggedTemplateLiteral([
        "\n  margin-left: 2rem;\n\n  .ant-badge {\n    &-status-dot {\n      ",
        ";\n      top: 0;\n    }\n\n    &-status-text {\n      ",
        ";\n    }\n  }\n"
    ]);
    post_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var smallFontMixin = function() {
    return (0,styled_components_browser_esm/* css */.iv)(post_styled_templateObject(), polished_esm/* rgba */.m4(colors.F1, 0.6));
};
var post_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(post_styled_templateObject1(), colors.T2, mixins/* lineClamp */.Sf(2), colors.B1, colors.B1);
var Row = styled_components_browser_esm/* default.div */.ZP.div(post_styled_templateObject2(), smallFontMixin());
var TitleRow = (0,styled_components_browser_esm/* default */.ZP)(Row)(post_styled_templateObject3());
var InformationRow = (0,styled_components_browser_esm/* default */.ZP)(Row)(post_styled_templateObject4(), mixins/* flexVerticalCenter */.VL());
var User = styled_components_browser_esm/* default.div */.ZP.div(post_styled_templateObject5(), smallFontMixin(), mixins/* size */.dp("21px"));
var post_styled_Tag = (0,styled_components_browser_esm/* default */.ZP)(badge/* default */.Z)(post_styled_templateObject6(), mixins/* size */.dp("8px"), smallFontMixin());

;// CONCATENATED MODULE: ./src/pages/home/blogs/blog/blog.styled.js
function blog_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function blog_styled_templateObject() {
    var data = blog_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  //padding-left: 40px;\n\n  ",
        " {\n    svg {\n      position: absolute;\n      height: 24px;\n      left: 0;\n      margin-top: 6px;\n    }\n  }\n"
    ]);
    blog_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var blog_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(post_styled_Container)(blog_styled_templateObject(), TitleRow);

;// CONCATENATED MODULE: ./src/pages/home/blogs/blog/Blog.component.js





// import AsktugIcon from './asktug.svg';
var Blog = function(param) {
    var title = param.title, link = param.link, creator = param.creator, updatedAt = param.updatedAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
            href: link,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleRow, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        title: title,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(User, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: creator.username,
                                    src: creator.avatarUrl
                                }),
                                creator.username
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: dayjs_min_default()(updatedAt).format("YYYY.MM.DD")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Blog_component = (Blog);

;// CONCATENATED MODULE: ./src/pages/home/blogs/blog/index.js


;// CONCATENATED MODULE: ./src/pages/home/blogs/Blogs.component.js
function Blogs_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Blogs_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Blogs_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var categories = [
    {
        name: "\u5B9E\u8DF5\u6848\u4F8B",
        link: "/blog/tag/practical-case"
    },
    {
        name: "TiDB \u5E95\u5C42\u67B6\u6784",
        link: "/blog/tag/tidb-underlying-architecture"
    },
    {
        name: "\u6545\u969C\u6392\u67E5/\u8BCA\u65AD",
        link: "/blog/tag/troubleshooting-and-diagnosis"
    },
    {
        name: "\u7BA1\u7406\u4E0E\u8FD0\u7EF4",
        link: "/blog/tag/management-and-operation-and-maintenance"
    },
    {
        name: "\u6027\u80FD\u8C03\u4F18",
        link: "/blog/tag/performance-tuning"
    },
    {
        name: "\u5B89\u88C5 & \u90E8\u7F72",
        link: "/blog/tag/install-and-deploy"
    },
    {
        name: "\u6570\u636E\u5E93\u67B6\u6784\u9009\u578B",
        link: "/blog/tag/database-architecture-selection"
    },
    {
        name: "\u76D1\u63A7",
        link: "/blog/tag/monitor"
    },
    {
        name: "\u7248\u672C\u6D4B\u8BC4",
        link: "/blog/tag/version-evaluation"
    },
    {
        name: "\u65B0\u7248\u672C/\u7279\u6027\u53D1\u5E03",
        link: "/blog/tag/new-version-features-released"
    }, 
];
var Blogs_component_Blogs = function() {
    var data = (0,react.useContext)(context/* PageDataContext */.A6).data;
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    var writeBlogButtonProps = {
        type: "primary",
        size: "large",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditFilled/* default */.Z, {}),
        children: "\u5199\u535A\u5BA2"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(blogs_styled_Container, {
        isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
            title: "\u535A\u5BA2\u6587\u7AE0",
            reverseOnSmallScreen: true,
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Blogs, {
                        children: data.blogs.map(function(blog, idx) {
                            var props = Blogs_component_objectSpread({
                                key: idx
                            }, blog);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_component, Blogs_component_objectSpread({}, props));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                        href: {
                            pathname: "/blog",
                            query: {
                                latest: true
                            }
                        },
                        children: "\u67E5\u770B\u5168\u90E8"
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(forum_styled_Module, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blogs_styled_ModuleTitle, {
                                justify: isSmallScreen && "center",
                                children: "\u60F3\u5206\u4EAB\u7ECF\u9A8C\uFF1F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "\u300C\u535A\u5BA2\u300D\u662F\u793E\u533A\u7684\u6280\u672F\u6587\u7AE0\u96C6\u5408\u5730\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u8FD9\u91CC\u67E5\u770B\u3001\u5206\u4EAB\u9AD8\u8D28\u91CF\u7684\u535A\u5BA2\u6587\u7AE0\uFF0C\u5B66\u4E60\u5E72\u8D27\u3002"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "\u53D1\u8868\u3001\u5206\u4EAB\u6280\u672F\u6587\u7AE0\u8BF7\u53C2\u8003",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        href: "/blog/66c5e81b",
                                        children: "\u6280\u672F\u6587\u7AE0\u64B0\u5199&\u53D1\u5E03\u6307\u5F15"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blogs_styled_CenterOnSmallScreen, {
                                isSmallScreen: isSmallScreen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                    href: "/blog/new/edit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, Blogs_component_objectSpread({}, writeBlogButtonProps))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(forum_styled_Module, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(blogs_styled_ModuleTitle, {
                                children: [
                                    "\u70ED\u95E8\u6807\u7B7E",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        href: "/blog",
                                        children: "\u67E5\u770B\u5168\u90E8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_component, {
                                categories: categories
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Blogs_component = (Blogs_component_Blogs);

;// CONCATENATED MODULE: ./src/pages/home/blogs/index.js


;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution.styled.js
function contribution_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function contribution_styled_templateObject() {
    var data = contribution_styled_taggedTemplateLiteral([
        ""
    ]);
    contribution_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject1() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  font-size: revert;\n  text-decoration: underline;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    contribution_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject2() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n      margin-bottom: 2rem;\n    "
    ]);
    contribution_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject3() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  margin-top: 2.5rem;\n  ",
        "\n"
    ]);
    contribution_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject4() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  margin-bottom: 1rem;\n"
    ]);
    contribution_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject5() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    contribution_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject6() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n"
    ]);
    contribution_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject7() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  border-radius: 6px;\n  margin-bottom: 2.5rem;\n  background-color: #181a24;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n"
    ]);
    contribution_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject8() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  font-weight: bold !important;\n"
    ]);
    contribution_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function contribution_styled_templateObject9() {
    var data = contribution_styled_taggedTemplateLiteral([
        "\n  line-height: 1.7;\n  font-size: 16px;\n"
    ]);
    contribution_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var contribution_styled_ModuleTitle = styled/* ModuleTitle */.$C, contribution_styled_Section = styled/* Section */.$0, contribution_styled_Text = styled/* Text */.xv;

var contribution_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(contribution_styled_Section)(contribution_styled_templateObject());
var contribution_styled_Link = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(contribution_styled_templateObject1(), colors.B1);
var StepBox = styled_components_browser_esm/* default.div */.ZP.div(contribution_styled_templateObject3(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(contribution_styled_templateObject2());
});
var StepHeader = styled_components_browser_esm/* default.div */.ZP.div(contribution_styled_templateObject4());
var iconSize = "38px";
var StepIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(contribution_styled_templateObject5(), mixins/* size */.dp(iconSize));
var EngageCallBox = styled_components_browser_esm/* default.div */.ZP.div(contribution_styled_templateObject6());
var IssueList = styled_components_browser_esm/* default.div */.ZP.div(contribution_styled_templateObject7());
var ForkTitle = (0,styled_components_browser_esm/* default */.ZP)(contribution_styled_ModuleTitle)(contribution_styled_templateObject8());
var EngageTitle = (0,styled_components_browser_esm/* default */.ZP)(contribution_styled_ModuleTitle)(contribution_styled_templateObject9());

;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-github-issues.jpg
/* harmony default export */ var contribution_github_issues = ({"src":"https://img1.tidb.net/_next/static/media/contribution-github-issues.63b61535.jpg","height":1078,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAACAQUBAAAAAAAAAAAAAAAAAQIEERIUITH/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIRAxEAPwCfVCerF35ivJAAuB//2Q=="});
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-github-logo.svg
var contribution_github_logo_path, contribution_github_logo_path2;
function contribution_github_logo_extends() { contribution_github_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_github_logo_extends.apply(this, arguments); }

var SvgContributionGithubLogo = function SvgContributionGithubLogo(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_github_logo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.257 35.362"
  }, props), contribution_github_logo_path || (contribution_github_logo_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.129 0A18.131 18.131 0 0 0 12.4 35.331c.906.168 1.239-.393 1.239-.872 0-.432-.017-1.86-.025-3.375C8.568 32.18 7.5 28.945 7.5 28.945a4.8 4.8 0 0 0-2.013-2.653c-1.645-1.125.124-1.1.124-1.1A3.811 3.811 0 0 1 8.39 27.06a3.859 3.859 0 0 0 5.275 1.507 3.861 3.861 0 0 1 1.151-2.424c-4.027-.459-8.26-2.013-8.26-8.959a7.016 7.016 0 0 1 1.868-4.866 6.514 6.514 0 0 1 .176-4.8s1.522-.487 4.987 1.858a17.2 17.2 0 0 1 9.079 0c3.46-2.346 4.98-1.858 4.98-1.858a6.506 6.506 0 0 1 .178 4.8 7 7 0 0 1 1.866 4.866c0 6.963-4.241 8.5-8.278 8.945a4.334 4.334 0 0 1 1.23 3.357c0 2.426-.021 4.378-.021 4.975 0 .482.326 1.048 1.245.87A18.131 18.131 0 0 0 18.129 0",
    fill: "#161614"
  })), contribution_github_logo_path2 || (contribution_github_logo_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6.79 25.825c-.04.09-.182.117-.311.055s-.205-.182-.163-.272.181-.119.312-.056.207.183.161.273m.892.8c-.086.08-.256.043-.37-.084a.277.277 0 0 1-.053-.377c.089-.08.253-.043.372.084s.142.3.051.377m.612 1.018c-.111.077-.293 0-.405-.156s-.111-.354 0-.432.291-.008.405.152.111.357 0 .436m1.035 1.179c-.1.109-.311.08-.466-.069a.349.349 0 0 1-.1-.463c.1-.11.313-.079.469.069s.205.355.1.463m1.337.4c-.044.142-.248.206-.453.146s-.339-.228-.3-.372.247-.21.454-.146.339.227.3.371m1.522.169c.005.15-.169.274-.385.276s-.392-.116-.394-.263.17-.274.387-.277.392.116.392.264m1.495-.057c.026.146-.124.3-.338.336s-.405-.052-.432-.2.127-.3.337-.338.406.05.434.2",
    fill: "#161614"
  })));
};
/* harmony default export */ var contribution_github_logo = (SvgContributionGithubLogo);
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-asktug-logo.svg
var _image;
function contribution_asktug_logo_extends() { contribution_asktug_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_asktug_logo_extends.apply(this, arguments); }

var SvgContributionAsktugLogo = function SvgContributionAsktugLogo(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_asktug_logo_extends({
    width: 38,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _image || (_image = /*#__PURE__*/react.createElement("image", {
    x: -4,
    y: -4,
    width: 44,
    height: 44,
    xlinkHref: "data:image/png;base64,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",
    fill: "none",
    fillRule: "evenodd"
  })));
};
/* harmony default export */ var contribution_asktug_logo = (SvgContributionAsktugLogo);
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-slack-logo.svg
var contribution_slack_logo_g;
function contribution_slack_logo_extends() { contribution_slack_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_slack_logo_extends.apply(this, arguments); }

var SvgContributionSlackLogo = function SvgContributionSlackLogo(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_slack_logo_extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), contribution_slack_logo_g || (contribution_slack_logo_g = /*#__PURE__*/react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13.531.42a3.634 3.634 0 1 0 0 7.268h3.628V4.055A3.634 3.634 0 0 0 13.531.42m0 9.693H3.859a3.635 3.635 0 1 0 0 7.27h9.672a3.635 3.635 0 1 0 0-7.27z",
    fill: "#36C5F0"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.593 13.747a3.628 3.628 0 0 0-7.256 0v3.636h3.628a3.632 3.632 0 0 0 3.628-3.636zm-9.673 0V4.054a3.628 3.628 0 0 0-7.255 0v9.693a3.628 3.628 0 0 0 7.255 0z",
    fill: "#2EB67D"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.292 35.782a3.634 3.634 0 1 0 0-7.268h-3.628v3.634a3.633 3.633 0 0 0 3.628 3.634zm0-9.694h9.673a3.635 3.635 0 1 0 0-7.27h-9.673a3.635 3.635 0 1 0 0 7.27z",
    fill: "#ECB22E"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M.231 22.454a3.628 3.628 0 0 0 7.256 0V18.82H3.859a3.631 3.631 0 0 0-3.628 3.634zm9.673 0v9.693a3.628 3.628 0 0 0 7.255 0v-9.691a3.628 3.628 0 0 0-7.255 0",
    fill: "#E01E5A"
  }))));
};
/* harmony default export */ var contribution_slack_logo = (SvgContributionSlackLogo);
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-step-1.svg
var contribution_step_1_style, contribution_step_1_g, _g2;
function contribution_step_1_extends() { contribution_step_1_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_step_1_extends.apply(this, arguments); }

var SvgContributionStep1 = function SvgContributionStep1(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_step_1_extends({
    id: "contribution-step-1_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40.1 40",
    style: {
      enableBackground: "new 0 0 40.1 40"
    },
    xmlSpace: "preserve"
  }, props), contribution_step_1_style || (contribution_step_1_style = /*#__PURE__*/react.createElement("style", null, ".contribution-step-1_svg__st2{fill:#e8eaf1}")), /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-1_svg__\\u7EC4_5634",
    transform: "translate(-211.698 -135.683)"
  }, /*#__PURE__*/react.createElement("circle", {
    id: "contribution-step-1_svg__\\u692D\\u5706_1282",
    cx: 219.7,
    cy: 143.7,
    r: 8,
    style: {
      fill: "#be1d32"
    }
  }), /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-1_svg__\\u8DEF\\u5F84_15836",
    d: "m243.7 161.7-8.1 14h16.2l-8.1-14z",
    style: {
      fill: "#172d72"
    }
  }), contribution_step_1_g || (contribution_step_1_g = /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-1_svg__\\u7EC4_5635",
    transform: "translate(213.774 155.683)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-1_svg__\\u8DEF\\u5F84_15837",
    className: "contribution-step-1_svg__st2",
    d: "M4 0H0c0 9.9 8 17.9 17.9 17.9v-4C10.2 13.9 4 7.7 4 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-1_svg__\\u7EC4_5636",
    transform: "translate(231.704 137.753)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-1_svg__\\u8DEF\\u5F84_15838",
    className: "contribution-step-1_svg__st2",
    d: "M17.9 17.9C17.9 8 9.9 0 0 0v4c7.7 0 13.9 6.2 13.9 13.9h4z"
  })))));
};
/* harmony default export */ var contribution_step_1 = (SvgContributionStep1);
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-step-2.svg
var contribution_step_2_style, contribution_step_2_g, contribution_step_2_g2;
function contribution_step_2_extends() { contribution_step_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_step_2_extends.apply(this, arguments); }

var SvgContributionStep2 = function SvgContributionStep2(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_step_2_extends({
    id: "contribution-step-2_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), contribution_step_2_style || (contribution_step_2_style = /*#__PURE__*/react.createElement("style", null, ".contribution-step-2_svg__st2{fill:#172d72}")), /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-2_svg__\\u7EC4_5629",
    transform: "translate(-1072.96 -245.9)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15832",
    d: "M1089 273.9v-4h-4c0 2.2-1.8 4-4 4s-4-1.8-4-4h-4v16h16v-4c2.2 0 4-1.8 4-4s-1.8-4-4-4z",
    style: {
      fill: "#be1d32"
    }
  }), /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15833",
    d: "M1097 257.9v4h4c0-2.2 1.8-4 4-4s4 1.8 4 4h4v-16h-16v4c-2.2 0-4 1.8-4 4s1.8 4 4 4z",
    style: {
      fill: "#e8eaf1"
    }
  }), contribution_step_2_g || (contribution_step_2_g = /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-2_svg__\\u7EC4_5629-2",
    transform: "translate(1072.96 245.9)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15834",
    className: "contribution-step-2_svg__st2",
    d: "M4 16H0V0h12v4H4v12z"
  }))), contribution_step_2_g2 || (contribution_step_2_g2 = /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-2_svg__\\u7EC4_5630",
    transform: "translate(1100.96 269.9)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15835",
    className: "contribution-step-2_svg__st2",
    d: "M12 16H0v-4h8V0h4v16z"
  })))));
};
/* harmony default export */ var contribution_step_2 = (SvgContributionStep2);
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-step-3.svg
var contribution_step_3_style, contribution_step_3_g, contribution_step_3_g2;
function contribution_step_3_extends() { contribution_step_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_step_3_extends.apply(this, arguments); }

var SvgContributionStep3 = function SvgContributionStep3(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_step_3_extends({
    id: "contribution-step-3_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 46.3 44",
    style: {
      enableBackground: "new 0 0 46.3 44"
    },
    xmlSpace: "preserve"
  }, props), contribution_step_3_style || (contribution_step_3_style = /*#__PURE__*/react.createElement("style", null, ".contribution-step-3_svg__st1{fill:#172d72}.contribution-step-3_svg__st2{fill:#be1d32}")), /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-3_svg__\\u7EC4_5631",
    transform: "translate(-765.052 -138.422)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4561",
    style: {
      fill: "#e8eaf1"
    },
    d: "M765.1 138.4h35v40h-35z"
  }), contribution_step_3_g || (contribution_step_3_g = /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-3_svg__\\u7EC4_5632",
    transform: "translate(782.672 153.84)"
  }, /*#__PURE__*/react.createElement("ellipse", {
    id: "contribution-step-3_svg__\\u692D\\u5706_1281",
    className: "contribution-step-3_svg__st1",
    cx: 4.4,
    cy: 24.1,
    rx: 4,
    ry: 4.5
  }), /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4562",
    transform: "rotate(-45.001 17.675 10.979)",
    className: "contribution-step-3_svg__st1",
    d: "M5.2 8h25v6h-25z"
  }))), contribution_step_3_g2 || (contribution_step_3_g2 = /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-3_svg__\\u7EC4_5633",
    transform: "translate(769.479 147.204)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4563",
    className: "contribution-step-3_svg__st2",
    d: "M0 0h22v4.4H0z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4564",
    className: "contribution-step-3_svg__st2",
    d: "M0 8.9h13.2v4.4H0z"
  })))));
};
/* harmony default export */ var contribution_step_3 = (SvgContributionStep3);
;// CONCATENATED MODULE: ./src/pages/home/contribution/contribution-step-4.svg
var contribution_step_4_style, contribution_step_4_circle, _circle2;
function contribution_step_4_extends() { contribution_step_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return contribution_step_4_extends.apply(this, arguments); }

var SvgContributionStep4 = function SvgContributionStep4(props) {
  return /*#__PURE__*/react.createElement("svg", contribution_step_4_extends({
    id: "contribution-step-4_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 40",
    style: {
      enableBackground: "new 0 0 32 40"
    },
    xmlSpace: "preserve"
  }, props), contribution_step_4_style || (contribution_step_4_style = /*#__PURE__*/react.createElement("style", null, ".contribution-step-4_svg__st2{fill:#be1d32}")), /*#__PURE__*/react.createElement("g", {
    id: "contribution-step-4_svg__\\u7EC4_5638",
    transform: "translate(-881.711 -141.422)"
  }, /*#__PURE__*/react.createElement("path", {
    id: "contribution-step-4_svg__\\u8DEF\\u5F84_15839",
    d: "m907.5 179-22-17.6 22-17.6 2.5 3.1-18 14.4 18 14.4-2.5 3.3z",
    style: {
      fill: "#e8eaf1"
    }
  }), /*#__PURE__*/react.createElement("circle", {
    id: "contribution-step-4_svg__\\u692D\\u5706_1283",
    cx: 889.7,
    cy: 161.4,
    r: 8,
    style: {
      fill: "#172d72"
    }
  }), contribution_step_4_circle || (contribution_step_4_circle = /*#__PURE__*/react.createElement("circle", {
    id: "contribution-step-4_svg__\\u692D\\u5706_1284",
    className: "contribution-step-4_svg__st2",
    cx: 907.6,
    cy: 147.4,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    id: "contribution-step-4_svg__\\u692D\\u5706_1285",
    className: "contribution-step-4_svg__st2",
    cx: 907.7,
    cy: 175.4,
    r: 6
  }))));
};
/* harmony default export */ var contribution_step_4 = (SvgContributionStep4);
;// CONCATENATED MODULE: ./src/pages/home/contribution/Contribution.component.jsx
function Contribution_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Contribution_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Contribution_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















var steps = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_step_1, {}),
        title: "\u5F00\u59CB\u51C6\u5907\u5DE5\u4F5C",
        desc: "\u5047\u8BBE\u4F60\u662F\u4E00\u4E2A TiDB \u65B0\u624B\uFF0C\u672C\u7AE0\u8282\u5C06\u6559\u4F60\u5B89\u88C5\u5F00\u53D1\u73AF\u5883\uFF0C\u6784\u5EFA\u5E76\u8FDE\u63A5\u5230 tidb-server\u3002",
        link: "https://pingcap.github.io/tidb-dev-guide/get-started/install-golang"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_step_2, {}),
        title: "\u4E3A TiDB \u505A\u8D21\u732E",
        desc: "\u5E2E\u52A9\u4F60\u5FEB\u901F\u53C2\u4E0E\u793E\u533A\uFF0C\u63CF\u8FF0\u4E86\u8D21\u732E\u7C7B\u578B\u4EE5\u53CA\u5982\u4F55\u5FEB\u901F\u5B9E\u73B0\u4F60\u7684 first contribution\u3002",
        link: "https://pingcap.github.io/tidb-dev-guide/contribute-to-tidb/introduction"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_step_3, {}),
        title: "\u6DF1\u5165\u4E86\u89E3 TiDB",
        desc: "\u5E2E\u52A9\u4F60\u719F\u6089\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u7684\u57FA\u672C\u6982\u5FF5\uFF0C\u5728\u8111\u6D77\u4E2D\u5EFA\u2F74\u77E5\u8BC6\u5E93\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u4E2D\u7684 SQL \u8BED\u2F94\u3001\u5173\u952E\u7EC4\u4EF6\u3001\u7B97\u6CD5\u3002\u5DF2\u7ECF\u719F\u6089\u8FD9\u4E9B\u5185\u5BB9\u7684\u540C\u5B66\u53EF\u4EE5\u8DF3\u8FC7\u672C\u8282\u3002 ",
        link: "https://pingcap.github.io/tidb-dev-guide/understand-tidb/introduction.html"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_step_4, {}),
        title: "\u9879\u76EE\u7BA1\u7406",
        desc: "\u5E2E\u52A9\u4F60\u53C2\u4E0E\u56E2\u961F\u2F2F\u4F5C\uFF0C\u4E3B\u5BFC\u529F\u80FD\u5F00\u53D1\uFF0C\u7BA1\u7406 TiDB \u793E\u533A\u4E2D\u7684\u9879\u2F6C\u3002",
        link: "https://pingcap.github.io/tidb-dev-guide/project-management/introduction"
    }, 
];
var fork = [
    {
        name: "github",
        label: "Github",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_github_logo, {
            height: 36,
            alt: "github logo"
        }),
        link: "https://github.com/pingcap/tidb"
    },
    {
        name: "asktug",
        label: "\u5F00\u53D1\u8005\u8BBA\u575B",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_asktug_logo, {
            height: 36,
            alt: "asktug logo"
        }),
        link: "https://internals.tidb.io/"
    },
    {
        name: "slack",
        label: "Slack",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_slack_logo, {
            height: 36,
            alt: "slack logo"
        }),
        link: "https://slack.tidb.io/"
    }, 
];
var Contribution = function() {
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_styled_Container, {
        id: "contribution",
        isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
            title: "\u5982\u4F55\u8D21\u732E\u4EE3\u7801",
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_styled_ModuleTitle, {
                        children: "\u5F00\u53D1\u8005\u6307\u5357"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_styled_Text, {
                        children: "\u65E8\u5728\u5E2E\u52A9\u8D21\u732E\u8005\u4ECE\u65B0\u624B\u6210\u957F\u4E3A TiDB \u4E13\u5BB6\uFF0C\u719F\u6089 TiDB \u7684\u8BBE\u8BA1\u548C\u5B9E\u65BD\uFF0C\u4ECE\u800C\u80FD\u591F\u5728\u73B0\u5B9E\u4E16\u754C\u4E2D\u6D41\u7545\u5730\u4F7F\u7528\u5B83\uFF0C\u5E76\u8FDB\u884C\u6DF1\u5165\u5F00\u53D1\u5DE5\u4F5C\u3002"
                    }),
                    steps.map(function(step, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepBox, {
                            isSmallScreen: isSmallScreen,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                gutter: 32,
                                wrap: false,
                                justify: isSmallScreen && "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        xs: {
                                            order: 2
                                        },
                                        md: {
                                            order: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepIconWrapper, {
                                            children: step.icon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                        xs: {
                                            order: 1
                                        },
                                        md: {
                                            order: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepHeader, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(contribution_styled_Link, {
                                                    href: step.link,
                                                    children: [
                                                        "Chapter ",
                                                        idx + 1,
                                                        " ",
                                                        ".",
                                                        " ",
                                                        step.title
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contribution_styled_Text, {
                                                children: step.desc
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, idx);
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IssueList, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Contribution_component_objectSpread({}, contribution_github_issues, {
                            width: 400,
                            height: 431,
                            quality: 75,
                            alt: "GitHub Pull Request \u5217\u8868\u622A\u56FE"
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        gutter: 16,
                        children: fork.map(function(el) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                title: el.label,
                                placement: "bottom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: el.link,
                                        children: el.icon
                                    })
                                })
                            }, el.label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EngageCallBox, {
                        isSmallScreen: isSmallScreen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EngageTitle, {
                            children: "\u73B0\u5728\uFF0C\u6765\u5F00\u53D1\u8005\u8BBA\u575B\u548C\u5185\u6838\u7814\u53D1\u5DE5\u7A0B\u5E08\u4EA4\u6D41\u5B66\u4E60\u5427\uFF01"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Contribution_component = (Contribution);

;// CONCATENATED MODULE: ./src/pages/home/contribution/index.js


;// CONCATENATED MODULE: ./src/pages/home/forum/post/Post.component.js
function Post_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Post_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Post_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Post = function(param1) {
    var title = param1.title, link = param1.link, creator = param1.creator, categories = param1.categories, postNum = param1.postNum, createdAt = param1.createdAt, isSmallScreen = param1.isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(post_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
            href: link,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            title: title,
                            children: title
                        }),
                        !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                postNum,
                                " \u56DE\u590D"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(User, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: creator.username,
                                            src: creator.avatarUrl
                                        }),
                                        creator.username
                                    ]
                                }),
                                !isSmallScreen && categories.map(function(param) {
                                    var id = param.id, color = param.color, name = param.name;
                                    var props = {
                                        key: id,
                                        color: "#".concat(color),
                                        text: name
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(post_styled_Tag, Post_component_objectSpread({}, props));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        postNum,
                                        " \u56DE\u590D"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: dayjs_min_default()(createdAt).fromNow()
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Post_component = (Post);

;// CONCATENATED MODULE: ./src/pages/home/forum/post/index.js


;// CONCATENATED MODULE: ./src/pages/home/forum/Forum.component.js
function Forum_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Forum_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Forum_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var Forum_component_categories = [
    {
        name: "TiDB \u6280\u672F\u95EE\u9898",
        link: "https://pingkai.cn/tidbcommunity/forum/c/administration/30022"
    },
    {
        name: "\u5E94\u7528\u5F00\u53D1\u8005\u4E13\u533A",
        link: "https://pingkai.cn/tidbcommunity/forum/c/developer/30055"
    },
    {
        name: "\u5176\u4ED6\u6280\u672F\u95EE\u9898",
        link: "https://pingkai.cn/tidbcommunity/forum/c/ecosystem/150022"
    },
    {
        name: "\u793E\u533A\u8D44\u8BAF\u53CA\u6D3B\u52A8",
        link: "https://pingkai.cn/tidbcommunity/forum/c/community-activities/30070"
    },
    {
        name: "\u8D44\u6E90\u4E2D\u5FC3",
        link: "https://pingkai.cn/tidbcommunity/forum/c/resource/300022"
    },
    {
        name: "\u4E92\u52A9\u4EA4\u6D41\u533A",
        link: "https://pingkai.cn/tidbcommunity/forum/c/Mutual-communication"
    },
    {
        name: "\u5B66\u4E60\u4E0E\u8BA4\u8BC1",
        link: "https://pingkai.cn/tidbcommunity/forum/c/pu"
    },
    {
        name: "\u5EFA\u8BAE & \u53CD\u9988",
        link: "https://pingkai.cn/tidbcommunity/forum/c/advice-feedback"
    },
    {
        name: "\u793E\u533A\u4E92\u52A9\u6307\u5357",
        link: "https://pingkai.cn/tidbcommunity/forum/t/topic/694770"
    },
    {
        name: "\u793E\u533A\u53C2\u4E0E\u6307\u5357",
        link: "https://pingkai.cn/tidbcommunity/forum/t/topic/695198"
    }, 
];
var Forum = function() {
    var data = (0,react.useContext)(context/* PageDataContext */.A6).data;
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    var writePostButtonProps = {
        type: "primary",
        size: "large",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditFilled/* default */.Z, {}),
        children: "\u5199\u5E16\u5B50"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(forum_styled_Container, {
        isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
            reverseOnSmallScreen: true,
            title: "\u95EE\u7B54\u8BBA\u575B",
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Posts, {
                        children: data.forumPosts.map(function(post, idx) {
                            var props = Forum_component_objectSpread({
                                key: idx
                            }, post, {
                                isSmallScreen: isSmallScreen
                            });
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_component, Forum_component_objectSpread({}, props));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                        href: "https://pingkai.cn/tidbcommunity/forum/",
                        children: "\u67E5\u770B\u5168\u90E8"
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(forum_styled_Module, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forum_styled_ModuleTitle, {
                                justify: isSmallScreen && "center",
                                children: "\u5FEB\u901F\u53D1\u5E16\u63D0\u95EE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AsktugLogo, {}),
                                    "AskTUG \u662F\u793E\u533A\u7684\u95EE\u7B54\u7F51\u7AD9\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u8FD9\u91CC\u63D0\u51FA\u3001\u89E3\u7B54\u95EE\u9898\uFF0C\u5206\u4EAB\u6587\u7AE0\uFF0C\u5171\u540C\u5EFA\u8BBE TiDB \u9879\u76EE\u3002"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "\u5728\u8BBA\u575B\u4E2D\u53D1\u8A00\u8BF7\u81EA\u89C9\u9075\u5B88",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                        href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93912",
                                        children: "\u300A\u95EE\u9898\u641C\u7D22\u6307\u5F15&\u63D0\u95EE\u51C6\u5219\u300B"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterOnSmallScreen, {
                                isSmallScreen: isSmallScreen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://pingkai.cn/tidbcommunity/forum/new-topic",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, Forum_component_objectSpread({}, writePostButtonProps))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(forum_styled_Module, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(forum_styled_ModuleTitle, {
                                children: [
                                    "\u70ED\u95E8\u5206\u7C7B",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                        href: "https://pingkai.cn/tidbcommunity/forum/",
                                        children: "\u67E5\u770B\u5168\u90E8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_component, {
                                categories: Forum_component_categories
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Forum_component = (Forum);

;// CONCATENATED MODULE: ./src/pages/home/forum/index.js


// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlayCircleFilled.js + 1 modules
var PlayCircleFilled = __webpack_require__(67874);
;// CONCATENATED MODULE: ./src/pages/home/learning/learning.styled.js
function learning_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function learning_styled_templateObject() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    learning_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function learning_styled_templateObject1() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    learning_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function learning_styled_templateObject2() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  color: inherit;\n  font-size: revert;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    learning_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function learning_styled_templateObject3() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 2rem;\n  width: 300px;\n"
    ]);
    learning_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function learning_styled_templateObject4() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  line-height: 1;\n  margin-top: 2.5rem;\n"
    ]);
    learning_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function learning_styled_templateObject5() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    learning_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function learning_styled_templateObject6() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  padding-bottom: 1rem;\n"
    ]);
    learning_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function learning_styled_templateObject7() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n      box-shadow: inset 0 0 0 8px ",
        ";\n    "
    ]);
    learning_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function learning_styled_templateObject8() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  background-size: auto 100%;\n  padding-bottom: 62.8%;\n  width: 100%;\n  background-image: url(",
        ");\n  border-color: ",
        ";\n\n  ",
        "\n"
    ]);
    learning_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function learning_styled_templateObject9() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  ",
        "\n  padding: 0.4rem;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.46);\n  z-index: 2;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: ",
        ";\n  font-size: 15px;\n  border: 8px solid white;\n  border-top: none;\n"
    ]);
    learning_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function learning_styled_templateObject10() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"
    ]);
    learning_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function learning_styled_templateObject11() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.46);\n  border: 8px solid white;\n  cursor: pointer;\n"
    ]);
    learning_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function learning_styled_templateObject12() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 14px;\n  padding: 16px;\n  text-align: center;\n"
    ]);
    learning_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function learning_styled_templateObject13() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n      font-size: 2rem;\n    "
    ]);
    learning_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function learning_styled_templateObject14() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  font-size: 5rem;\n  color: ",
        ";\n  opacity: 46%;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n\n  ",
        "\n"
    ]);
    learning_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function learning_styled_templateObject15() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n      transform: translateX(-8px);\n    "
    ]);
    learning_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function learning_styled_templateObject16() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    learning_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function learning_styled_templateObject17() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  height: 33.3%;\n"
    ]);
    learning_styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n      margin-bottom: 3rem;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = learning_styled_taggedTemplateLiteral([
        "\n  display: block;\n  margin-top: 1rem;\n  text-decoration: underline;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}





var learning_styled_Section = styled/* Section */.$0, learning_styled_Text = styled/* Text */.xv, learning_styled_ModuleTitle = styled/* ModuleTitle */.$C;
var learning_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(learning_styled_Section)(learning_styled_templateObject(), colors.M2);

var learning_styled_Link = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(learning_styled_templateObject1(), colors.F2, colors.B1);
var TitleLink = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(learning_styled_templateObject2(), colors.B1);
var learning_styled_Logo = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject3());
var VideoHeader = styled_components_browser_esm/* default.h3 */.ZP.h3(learning_styled_templateObject4());
var LinksRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(learning_styled_templateObject5());
var LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(learning_styled_templateObject6());
var VideoBox = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject8(), function(param) {
    var $src = param.$src;
    return $src;
}, colors.M1, function(props) {
    return !props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(learning_styled_templateObject7(), colors.M1);
});
var VideoCaption = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject9(), mixins/* lineClamp */.Sf(2), colors.M1);
var VideoPlayButton = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject10(), mixins/* flexCenter */._7, mixins/* flexVerticalCenter */.VL());
var VideoOverlay = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(learning_styled_templateObject11(), mixins/* flexCenter */._7, mixins/* flexVerticalCenter */.VL());
var VideoOverlayText = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject12(), colors.M1);
var VideoPlayIcon = (0,styled_components_browser_esm/* default */.ZP)(PlayCircleFilled/* default */.Z)(learning_styled_templateObject14(), colors.F1, colors.F2, function(props) {
    return props.$small && (0,styled_components_browser_esm/* css */.iv)(learning_styled_templateObject13());
});
var VideoBoxWrapper = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject16(), function(props) {
    return !props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(learning_styled_templateObject15());
});
var VideoBoxWrapperSmall = styled_components_browser_esm/* default.div */.ZP.div(learning_styled_templateObject17());
var VideosRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject18());
var More = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject20(), colors.B1, function(props) {
    return props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject19());
});

;// CONCATENATED MODULE: ./src/pages/home/learning/learn-minor-video-1-cover.jpg
/* harmony default export */ var learn_minor_video_1_cover = ({"src":"https://img1.tidb.net/_next/static/media/learn-minor-video-1-cover.b2e2fee3.jpg","height":583,"width":816,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQIDETEycf/EABUBAQEAAAAAAAAAAAAAAAAAAAAF/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAMx/9oADAMBAAIRAxEAPwCg2KmtJKtyk49OT35kAEauj//Z"});
;// CONCATENATED MODULE: ./src/pages/home/learning/learn-minor-video-2-cover.jpg
/* harmony default export */ var learn_minor_video_2_cover = ({"src":"https://img1.tidb.net/_next/static/media/learn-minor-video-2-cover.c9e200a2.jpg","height":583,"width":817,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAgMBAAAAAAAAAAAAAAACAwABITFRof/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/ALRTAYgqYgRYAbErvPnYiJfCR//Z"});
;// CONCATENATED MODULE: ./src/pages/home/learning/learn-minor-video-3-cover.jpg
/* harmony default export */ var learn_minor_video_3_cover = ({"src":"https://img1.tidb.net/_next/static/media/learn-minor-video-3-cover.b36ca87e.jpg","height":583,"width":816,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgEFAAAAAAAAAAAAAAAAAgEDEQQSFCGx/8QAFQEBAQAAAAAAAAAAAAAAAAAABQb/xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAMAwEAAhEDEQA/AKiNXX3TxklpXG+WbPoAKMMjVv/Z"});
;// CONCATENATED MODULE: ./src/pages/home/learning/learning-pingcap-education.svg
var _defs, learning_pingcap_education_path, learning_pingcap_education_path2;
function learning_pingcap_education_extends() { learning_pingcap_education_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return learning_pingcap_education_extends.apply(this, arguments); }

var SvgLearningPingcapEducation = function SvgLearningPingcapEducation(props) {
  return /*#__PURE__*/react.createElement("svg", learning_pingcap_education_extends({
    id: "learning-pingcap-education_svg___\\u56FE\\u5C42_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 585.16 150.48"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".learning-pingcap-education_svg__cls-2{stroke-width:0;fill:#d31834}"))), /*#__PURE__*/react.createElement("g", {
    id: "learning-pingcap-education_svg___\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.92 146.73Z",
    style: {
      fill: "#e9e9e9",
      strokeWidth: 0
    }
  }), learning_pingcap_education_path || (learning_pingcap_education_path = /*#__PURE__*/react.createElement("path", {
    className: "learning-pingcap-education_svg__cls-2",
    d: "M14.92 116.84h107.4V.48H14.78C6.62.48 0 7.1 0 15.27v115.97c.29-8 6.85-14.39 14.92-14.39Z"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M61.16 25.3 31.22 42.59v34.57l29.94 17.29L91.1 77.16V42.59L61.16 25.3Zm-.02 23.02V82.9l-9.94-5.73V54.06l-9.95 5.74V48.32l19.88-11.48 9.94 5.74-9.94 5.74Zm19.98 23.07-9.98 5.76V54.11l9.98-5.77v23.05Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M122.31 120.49H15.63c-.36-.02-.73-.02-1.09 0-6.09.3-10.78 5.48-10.47 11.57.3 6.09 5.48 10.78 11.57 10.47h106.68v-22.04Z",
    style: {
      fill: "#e5e5e4",
      strokeWidth: 0
    }
  }), learning_pingcap_education_path2 || (learning_pingcap_education_path2 = /*#__PURE__*/react.createElement("path", {
    id: "learning-pingcap-education_svg__Path_731",
    className: "learning-pingcap-education_svg__cls-2",
    d: "M42.35 131.23H20.08v19.25l11.1-6.15 11.17 6.15v-19.25Z"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M214.68 29.2V10.8h-20.39V3.62h48.27v7.18h-20.33v18.4h23.83v7.3h-23.83v20.03h-7.54V36.5H191.1v-7.3h23.59Zm-10.14-16.47c2.05 3.92 4.16 8.99 4.89 12.37l-7.06 2.23c-.6-3.26-2.47-8.57-4.46-12.61l6.64-1.99Zm35.54 1.81c-2.17 4.64-4.65 9.53-6.7 12.67l-6.33-1.87c1.93-3.5 4.1-8.81 5.25-12.79l7.78 1.99Zm23.77 35.05c.91-.48 1.57-1.33 1.57-3.62V33.42h17.26v-4.83h-18.34v-6.33h24.92v17.56h-17.8V47l15.02-3.02c.06 1.87.36 4.59.72 6.09-16.77 3.74-19.43 4.4-21.12 5.31-.3-1.57-1.33-4.4-2.23-5.79ZM270.3 3.2v9.89h3.92V0h6.15v13.09h3.74V3.2h6.03v15.51h-25.58V3.2h5.73Zm41.69-.42v44.04c0 2.54.06 2.84.6 2.84h1.09c.6 0 .78-1.63.9-7.78 1.39 1.03 3.74 2.17 5.43 2.65-.42 7.66-1.93 10.44-5.79 10.44h-3.02c-4.52 0-5.61-1.93-5.61-8.21V8.87h-5.13V21.9c0 10.26-1.09 25.46-8.08 34.81-1.03-1.21-3.86-3.62-5.25-4.4 6.15-8.57 6.7-21.18 6.7-30.41V2.78h18.16Zm71.91-.73v22.5h-36.2l5.01 1.45c-.54 1.09-1.09 2.23-1.75 3.32h8.81v-3.68h7.48v3.68h18.94v6.03h-18.94v3.68h16.23v5.67h-16.23v4.1h22.81v6.21h-53.4V48.8h23.11v-4.1h-15.63v-5.67h15.63v-3.68h-12.85c-1.81 2.29-3.74 4.4-5.55 6.03-1.39-1.27-4.34-3.5-6.09-4.46 4.04-3.02 7.84-7.66 10.08-12.37h-2.84V2.05h41.39Zm-34.27 8.63h26.79V7.54h-26.79v3.14Zm0 8.38h26.79V15.8h-26.79v3.26ZM421 51.1c1.39-1.09 3.2-3.2 3.2-6.39v-13.7h-4.46c-.6 8.93-2.17 19-6.15 26.06-1.51-1.21-4.89-3.14-6.82-3.86 5.31-9.17 5.73-22.75 5.73-32.28V2.23h49.29v7.06h-41.75v11.64l-.06 3.38h43.2v6.7h-7.42l6.27 4.04c-3.26 2.54-7.06 5.25-10.32 7.3 3.44 3.02 7.66 5.31 12.73 6.76-1.63 1.45-3.74 4.34-4.77 6.28-11.89-4.1-19-12.43-23.29-24.38h-4.77v15.75l10.38-2.47c-.18 2.11-.18 5.13.06 6.82-13.27 3.56-15.75 4.53-17.26 5.49-.6-1.51-2.59-4.34-3.8-5.49Zm37.11-37.64v6.58H423.6v-6.58h34.51Zm-10.56 24.55c2.9-2.23 5.97-4.83 8.02-7h-12.13a32.47 32.47 0 0 0 4.1 7Zm-250 89.1V107.1h-6.73v-4.05h6.73V89.82h3.93v13.23h6.5v4.05h-6.5v18.53l6.67-2.57.8 3.93c-6.04 2.51-12.37 5.07-17.22 7.01l-1.37-4.33c2-.68 4.45-1.54 7.18-2.57Zm39.56-26.16c-1.25 3.48-2.79 7.58-4.16 10.72h10.09v3.88H207.7v-3.88h21.38c1.48-3.31 3.19-8.32 4.05-11.8l3.99 1.08Zm-11.06-12.09c.86 2.11 1.6 4.85 1.94 6.78h13.23v3.88h-31.35v-3.88h13.97c-.34-1.88-.91-4.28-1.6-6.16l3.82-.63Zm12.32 31.7v20.81h-4.1v-2.28h-17.61v2.45h-3.99v-20.98h25.71Zm-21.15-20.47c1.6 3.08 2.91 7.01 3.36 9.69l-3.65 1.2c-.4-2.68-1.71-6.73-3.14-9.86l3.42-1.03Zm17.04 35.12v-10.83h-17.61v10.83h17.61Zm47.19 2.16c1.03-.85 2.74-2.74 2.74-5.53V111.2h-8.09v-4.16h12.2v23.83l5.36-4.33c.46 1.14 1.2 2.74 1.77 3.53-9.29 7.75-10.83 9.12-11.63 10.32v.06c-.46-.91-1.6-2.45-2.34-3.08Zm.57-46.97c3.42 2.68 7.87 6.5 9.92 9.01l-2.85 3.19c-2.05-2.51-6.33-6.56-9.75-9.35l2.68-2.85Zm20.53.4v19.84c0 10.95-.63 21.89-6.27 30.9-.91-.8-2.74-2-3.99-2.45 5.42-8.38 6.04-18.36 6.04-28.5V90.81h4.22Zm11.8 2.79v40.65h-3.99V93.59h3.99Zm12.14-3.02v50.28h-4.28V90.57h4.28Zm71.65 32.89v4.1h-35.57v-4.1h35.57Zm-19.67-32.6-1.2 6.16h31.98v4.1h-32.84c-.74 3.59-1.54 7.18-2.22 10.26h35.91s-.06 1.48-.17 2.11c-1.65 16.3-3.19 22.92-5.81 25.42-1.48 1.48-2.96 1.82-5.42 2-2.05.11-6.16 0-10.2-.23-.11-1.31-.74-3.08-1.6-4.28 4.45.4 8.89.46 10.55.46 1.42 0 2.22-.06 2.96-.68 2.11-1.71 3.59-7.7 4.9-20.75h-33.06l-3.59-.06c1.77-6.33 4.1-17.1 5.53-24.97l4.28.46Zm82.76 16.19v23.49l7.07-4.73c.29 1.14.85 2.74 1.25 3.59-10.89 7.64-12.43 8.84-13.23 9.92-.4-.91-1.6-2.39-2.39-3.14 1.2-.8 3.14-2.74 3.14-5.47v-19.55h-9.58v-4.1h13.74Zm-5.47-16.82c2.85 2.45 6.78 5.93 8.72 8.04l-3.02 3.14c-1.82-2.17-5.7-5.93-8.55-8.55l2.85-2.62Zm28.85-1.03c-.06 5.87-.06 11.86-.46 17.56.74 5.53 3.36 23.6 15.85 31.64-1.14.8-2.39 2.05-3.14 3.14-8.04-5.47-12.09-15.11-14.25-23.15-1.88 9.46-5.7 17.67-13.34 23.2-.74-.97-2.11-2.28-3.25-2.96 14.42-10.09 14.14-30.1 14.25-49.43h4.33Zm60.75 17.85v23.6l5.7-4.33c.4 1.08 1.2 2.79 1.71 3.65-9.75 7.64-11.29 8.89-12.14 10.03-.51-.85-1.88-2.28-2.62-2.91 1.08-.91 3.19-3.13 3.19-6.16v-19.78h-8.04v-4.1h12.2Zm-6.44-16.42c3.14 2.45 7.13 6.04 9.01 8.38l-2.96 2.96c-1.88-2.39-5.76-6.1-8.84-8.78l2.79-2.57Zm16.36 44.69v-27.48h4.22v27.48h7.7v-37.8h-14.88v-3.99h31.58v3.99h-12.31v14.94h11.29v4.05h-11.29v18.81h13.57v3.99h-34.77v-3.99h4.9Z",
    style: {
      fill: "#272935",
      strokeWidth: 0
    }
  })));
};
/* harmony default export */ var learning_pingcap_education = (SvgLearningPingcapEducation);
;// CONCATENATED MODULE: ./src/pages/home/learning/Learning.component.js











var minorVideos = [
    {
        title: "TiDB \u7279\u6709\u529F\u80FD\u4E0E\u4E8B\u52A1\u63A7\u5236",
        link: "https://learn.pingcap.cn/learner/course/750002",
        coverImage: learn_minor_video_1_cover
    },
    {
        title: "\u5728 TiDB \u4E0A\u5F00\u53D1\u5E94\u7528\u7684\u6700\u4F73\u5B9E\u8DF5",
        link: "https://learn.pingcap.cn/learner/course/780002",
        coverImage: learn_minor_video_2_cover
    },
    {
        title: "TiDB \u6570\u636E\u5E93\u6838\u5FC3\u539F\u7406\u4E0E\u67B6\u6784",
        link: "https://learn.pingcap.cn/learner/course/960001",
        coverImage: learn_minor_video_3_cover
    }, 
];
var linkSections = [
    {
        title: "\u9047\u5230\u95EE\u9898\uFF0C\u9700\u8981\u5E2E\u52A9\uFF1F",
        links: [
            {
                link: "https://pingkai.cn/tidbcommunity/forum/",
                label: "AskTUG \u8BBA\u575B"
            }, 
        ]
    },
    {
        title: "\u60F3\u83B7\u5F97\u66F4\u591A\u8865\u5145\u5B66\u4E60\u8D44\u6599\uFF1F",
        links: [
            {
                link: "https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb",
                label: "\u5FEB\u901F\u4E0A\u624B\u6307\u5357"
            },
            {
                link: "https://docs.pingcap.com/zh/tidb/stable/tidb-faq",
                label: "\u5E38\u89C1\u95EE\u9898\u89E3\u7B54"
            },
            {
                link: "https://docs.pingcap.com/zh/tidb/stable/release-notes",
                label: "\u7248\u672C\u53D1\u5E03\u5386\u53F2"
            },
            {
                link: "https://docs.pingcap.com/zh",
                label: "\u66F4\u591A\u6587\u6863\u8D44\u6599"
            }, 
        ]
    },
    {
        title: "\u60F3\u4E86\u89E3\u66F4\u591A\u5B9E\u8DF5\u6848\u4F8B\uFF1F",
        links: [
            {
                link: "/blog",
                label: "\u535A\u5BA2"
            }, 
        ]
    },
    {
        title: "\u60F3\u548C\u5176\u4ED6\u4F19\u4F34\u4EA4\u6D41\u5B66\u4E60\uFF1F",
        links: [
            {
                link: "/tug",
                label: "TiDB User Group"
            },
            {
                link: "/events",
                label: "\u53C2\u4E0E\u6D3B\u52A8"
            }, 
        ]
    }, 
];
var Learning = function() {
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_Container, {
        id: "learning",
        isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
            title: "\u5982\u4F55\u4F7F\u7528 TiDB",
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_Logo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_pingcap_education, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(learning_styled_Text, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_Link, {
                                href: "https://learn.pingcap.cn/learner/home",
                                children: "\u5E73\u51EF\u661F\u8FB0\u57F9\u8BAD\u4E0E\u8BA4\u8BC1"
                            }),
                            " ",
                            "\u81F4\u529B\u4E8E\u57F9\u517B\u5F00\u53D1\u3001\u7BA1\u7406\u53CA\u5E94\u7528\u5206\u5E03\u5F0F\u5173\u7CFB\u578B\u6570\u636E\u5E93\u7CFB\u7EDF\u7684\u4E00\u6D41\u4EBA\u624D\u3002\u83B7\u5F97",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_Link, {
                                href: "https://learn.pingcap.cn/learner/certification-center",
                                children: "\u80FD\u529B\u8BA4\u8BC1"
                            }),
                            "\u7684 TiDB \u4EBA\u624D\u5C06\u5728\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u9886\u57DF\u5F00\u542F\u9AD8\u4EAE\u804C\u4E1A\u751F\u6DAF\uFF0C\u62E5\u62B1\u65E0\u9650\u53EF\u80FD\u3002"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleLink, {
                            href: "https://learn.pingcap.cn/learner/course/600003",
                            children: "TiDB \u7684\u67B6\u6784\u4E0E\u7279\u70B9"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideosRow, {
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                md: 18,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBoxWrapper, {
                                    $isSmallScreen: isSmallScreen,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoBox, {
                                        $isSmallScreen: isSmallScreen,
                                        $src: learn_minor_video_1_cover.src,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayButton, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                    href: "https://learn.pingcap.cn/learner/course/600003",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayIcon, {
                                                        color: "white",
                                                        height: "48px"
                                                    })
                                                })
                                            }),
                                            !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCaption, {
                                                isSmallScreen: isSmallScreen,
                                                children: "\u5B66\u4E60\u6784\u5EFA TiDB \u5206\u5E03\u5F0F\u6570\u636E\u5E93\u96C6\u7FA4\u7684\u6838\u5FC3\u7EC4\u4EF6\u53CA\u5176\u6982\u5FF5\u3002"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 0,
                                md: 6,
                                children: minorVideos.map(function(video, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBoxWrapperSmall, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBox, {
                                            $isSmallScreen: isSmallScreen,
                                            $src: video.coverImage.src,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOverlay, {
                                                href: video.link,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOverlayText, {
                                                    children: video.title
                                                })
                                            })
                                        })
                                    }, idx);
                                })
                            })
                        ]
                    }),
                    isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_Text, {
                        children: "\u5B66\u4E60\u6784\u5EFA TiDB \u5206\u5E03\u5F0F\u6570\u636E\u5E93\u96C6\u7FA4\u7684\u6838\u5FC3\u7EC4\u4EF6\u53CA\u5176\u6982\u5FF5\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(More, {
                        href: "https://learn.pingcap.cn/learner/course",
                        $isSmallScreen: isSmallScreen,
                        children: "\u66F4\u591A\u8BFE\u7A0B"
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: linkSections.map(function(section, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_ModuleTitle, {
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinksRow, {
                                gutter: 32,
                                children: section.links.map(function(link, linkIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                                        flex: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_styled_Link, {
                                            href: link.link,
                                            children: link.label
                                        })
                                    }, linkIdx);
                                })
                            })
                        ]
                    }, idx);
                })
            })
        })
    });
};
/* harmony default export */ var Learning_component = (Learning);

;// CONCATENATED MODULE: ./src/pages/home/learning/index.js


// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlaySquareOutlined.js + 1 modules
var PlaySquareOutlined = __webpack_require__(61727);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ClockCircleOutlined.js + 1 modules
var ClockCircleOutlined = __webpack_require__(24019);
;// CONCATENATED MODULE: ./src/pages/home/others/videoThumbnail/videoThumbnail.style.js
function videoThumbnail_style_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function videoThumbnail_style_templateObject() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  position: relative;\n"
    ]);
    videoThumbnail_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject1() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    videoThumbnail_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject2() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: block;\n  padding-bottom: 1rem;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    videoThumbnail_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject3() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  ",
        ";\n  background-image: url(",
        ");\n  background-size: auto 100%;\n  padding-bottom: 62.8%;\n  border-radius: 4px;\n"
    ]);
    videoThumbnail_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject4() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border-bottom-right-radius: 4px;\n  border-top-left-radius: 4px;\n  font-size: 12px;\n  color: ",
        ";\n  padding-right: 4px;\n  padding-left: 4px;\n  background-color: rgb(0, 0, 0, 0.4);\n"
    ]);
    videoThumbnail_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject5() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  ",
        ";\n  font-size: 14px;\n  line-height: 1.75;\n  margin-top: 0.75rem;\n"
    ]);
    videoThumbnail_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject6() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    videoThumbnail_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function videoThumbnail_style_templateObject7() {
    var data = videoThumbnail_style_taggedTemplateLiteral([
        "\n  gap: 4px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 14px;\n  color: ",
        ";\n  padding-right: 1rem;\n"
    ]);
    videoThumbnail_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var PreviewWrapper = styled_components_browser_esm/* default.div */.ZP.div(videoThumbnail_style_templateObject());
var videoThumbnail_style_VideoBox = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(videoThumbnail_style_templateObject2(), colors.B1, function(props) {
    return props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(videoThumbnail_style_templateObject1());
});
var Preview = styled_components_browser_esm/* default.div */.ZP.div(videoThumbnail_style_templateObject3(), mixins/* size */.dp("100%", "100px"), function(props) {
    return props.src;
});
var Length = styled_components_browser_esm/* default.div */.ZP.div(videoThumbnail_style_templateObject4(), colors.M1);
var Title = styled_components_browser_esm/* default.div */.ZP.div(videoThumbnail_style_templateObject5(), mixins/* lineClamp */.Sf(2));
var MetaBox = styled_components_browser_esm/* default.div */.ZP.div(videoThumbnail_style_templateObject6());
var IconWrapper = styled_components_browser_esm/* default.span */.ZP.span(videoThumbnail_style_templateObject7(), colors.C4);

;// CONCATENATED MODULE: ./src/pages/home/others/videoThumbnail/VideoThumbnail.component.js



var VideoThumbnail = function(param) {
    var $isSmallScreen = param.$isSmallScreen, coverImage = param.coverImage, length = param.length, title = param.title, playCount = param.playCount, created = param.created, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(videoThumbnail_style_VideoBox, {
        $isSmallScreen: $isSmallScreen,
        href: link,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview, {
                        src: coverImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Length, {
                        children: length
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaySquareOutlined/* default */.Z, {}),
                    playCount
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockCircleOutlined/* default */.Z, {}),
                    created
                ]
            })
        ]
    });
};
/* harmony default export */ var VideoThumbnail_component = (VideoThumbnail);

;// CONCATENATED MODULE: ./src/pages/home/others/videoThumbnail/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
;// CONCATENATED MODULE: ./src/pages/home/others/others.styled.js
function others_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function others_styled_templateObject() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    others_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function others_styled_templateObject1() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 16px;\n  text-decoration: underline;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    others_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function others_styled_templateObject2() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    others_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function others_styled_templateObject3() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    others_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function others_styled_templateObject4() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  font-size: 20px;\n"
    ]);
    others_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function others_styled_templateObject5() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n"
    ]);
    others_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function others_styled_templateObject6() {
    var data = others_styled_taggedTemplateLiteral([
        "\n      margin-bottom: 1rem;\n    "
    ]);
    others_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function others_styled_templateObject7() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n\n  ",
        "\n\n  img {\n    width: auto;\n    height: 40px;\n  }\n"
    ]);
    others_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function others_styled_templateObject8() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  border: 0;\n  border-bottom: 1px solid ",
        ";\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n"
    ]);
    others_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var others_styled_ModuleTitle = styled/* ModuleTitle */.$C, others_styled_Section = styled/* Section */.$0, others_styled_Text = styled/* Text */.xv;

var SmallerText = (0,styled_components_browser_esm/* default */.ZP)(others_styled_Text)(others_styled_templateObject());
var others_styled_Link = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(others_styled_templateObject1(), colors.B1);
var SmallerLink = (0,styled_components_browser_esm/* default */.ZP)(others_styled_Link)(others_styled_templateObject2());
var others_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(others_styled_Section)(others_styled_templateObject3(), colors.M2);
var Subtitle = styled_components_browser_esm/* default.span */.ZP.span(others_styled_templateObject4());
var LogoWrapper = styled_components_browser_esm/* default.div */.ZP.div(others_styled_templateObject5());
var LogosBox = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(others_styled_templateObject7(), function(props) {
    return props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(others_styled_templateObject6());
});
var Divider = styled_components_browser_esm/* default.hr */.ZP.hr(others_styled_templateObject8(), colors.T2);

;// CONCATENATED MODULE: ./src/pages/home/others/others-pingcap-logo.svg
var others_pingcap_logo_path, others_pingcap_logo_path2, others_pingcap_logo_path3;
function others_pingcap_logo_extends() { others_pingcap_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return others_pingcap_logo_extends.apply(this, arguments); }

var SvgOthersPingcapLogo = function SvgOthersPingcapLogo(props) {
  return /*#__PURE__*/react.createElement("svg", others_pingcap_logo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.064 28"
  }, props), others_pingcap_logo_path || (others_pingcap_logo_path = /*#__PURE__*/react.createElement("path", {
    d: "M91.238 17.876h-.005l-.036.058a6.377 6.377 0 0 1-2.182 2.083 5.84 5.84 0 0 1-2.987.864 5.964 5.964 0 0 1-4.521-2.063 6.971 6.971 0 0 1-1.81-4.928 6.861 6.861 0 0 1 1.868-4.675 6.05 6.05 0 0 1 9.612.926l.037.057h.035l1.485-.918a8.234 8.234 0 0 0-2.453-2.608 7.657 7.657 0 0 0-4.252-1.286 7.457 7.457 0 0 0-5.677 2.419 8.533 8.533 0 0 0-2.382 6.168 8.918 8.918 0 0 0 2.36 6.187 7.415 7.415 0 0 0 5.62 2.55h.081a7.775 7.775 0 0 0 6.7-3.913zM102.326 5.6h-2.018l-7.5 16.788h2.393l2.318-5.58.819-1.744 3.019-7.085 2.959 7.085h-4.247l-.774 1.744h5.711l2.339 5.58h2.11zm18.106 1.537a6.015 6.015 0 0 0-4.165-1.515h-5.432v16.765h1.979V7.429h3.539a3.93 3.93 0 0 1 2.58.9 2.88 2.88 0 0 1 1.173 2.222 2.948 2.948 0 0 1-1.052 2.556 3.721 3.721 0 0 1-2.594.953h-2.05v1.765h2.372a5.3 5.3 0 0 0 3.694-1.408 4.611 4.611 0 0 0 1.588-3.486 4.744 4.744 0 0 0-1.632-3.794zM46.721 5.931H48.7V7.91h-1.979zm0 4.434H48.7v12.049h-1.979zm29.807 10.844v-5.174a6.579 6.579 0 0 0-6.618-6.55 6.229 6.229 0 0 0-4.426 1.994 6.385 6.385 0 0 0-1.8 4.533 6.512 6.512 0 0 0 1.948 4.707 6.046 6.046 0 0 0 4.648 1.863 6.169 6.169 0 0 0 4.371-1.961v.821m0 0a3.765 3.765 0 0 1-1.29 2.845 4.313 4.313 0 0 1-3.021 1.23 4.423 4.423 0 0 1-2.692-.9 4.126 4.126 0 0 1-1.427-1.677l-1.515.875a5.81 5.81 0 0 0 1.582 1.912 6.5 6.5 0 0 0 3.854 1.359c.094 0 .188.005.282.005a6.5 6.5 0 0 0 4.141-1.472 4.858 4.858 0 0 0 1.959-3.944v-.469m-1.909-5.046a4.648 4.648 0 0 1-1.337 3.217 4.088 4.088 0 0 1-3.1 1.333 4.341 4.341 0 0 1-3.212-1.335 4.484 4.484 0 0 1-1.378-3.236 4.558 4.558 0 0 1 1.254-3.279 4.334 4.334 0 0 1 3.107-1.5c.081 0 .16-.006.239-.006a4.062 4.062 0 0 1 3.094 1.382 4.533 4.533 0 0 1 1.333 3.424zM43.198 7.137a6.016 6.016 0 0 0-4.165-1.515h-5.432v16.765h1.979V7.429h3.539a3.93 3.93 0 0 1 2.581.9 2.879 2.879 0 0 1 1.173 2.222 2.948 2.948 0 0 1-1.052 2.556 3.722 3.722 0 0 1-2.594.953h-2.05v1.765h2.372a5.305 5.305 0 0 0 3.694-1.408 4.611 4.611 0 0 0 1.588-3.486 4.744 4.744 0 0 0-1.633-3.794zM56.47 9.628a5.349 5.349 0 0 0-3.966 1.622 5.55 5.55 0 0 0-1.578 4.028v7.084h1.909v-7.259a3.466 3.466 0 0 1 1.074-2.56 3.51 3.51 0 0 1 2.56-1.074 3.418 3.418 0 0 1 2.517 1.078 3.479 3.479 0 0 1 1.1 2.56v7.255h1.909v-7.084a5.55 5.55 0 0 0-1.578-4.028 5.323 5.323 0 0 0-3.947-1.622zm-42.471-3.1L1.693 3.064a1.333 1.333 0 0 0-1.165.214A1.293 1.293 0 0 0 0 4.324v22.364a1.3 1.3 0 0 0 .505 1.028 1.332 1.332 0 0 0 .821.282 1.36 1.36 0 0 0 .311-.036l12.307-2.892a1.31 1.31 0 0 0 1.02-1.274V7.787a1.319 1.319 0 0 0-.965-1.259z",
    fill: "#172d72"
  })), others_pingcap_logo_path2 || (others_pingcap_logo_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M22.382 5.732a1.319 1.319 0 0 0-.963-1.256L5.755.052a1.333 1.333 0 0 0-1.166.213 1.293 1.293 0 0 0-.529 1.046v16.97a1.3 1.3 0 0 0 .506 1.029 1.333 1.333 0 0 0 .819.281 1.349 1.349 0 0 0 .314-.037l15.682-3.722a1.309 1.309 0 0 0 1.018-1.276z",
    fill: "#00aeef"
  })), others_pingcap_logo_path3 || (others_pingcap_logo_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M13.999 6.528 4.061 3.733v14.548a1.3 1.3 0 0 0 .506 1.029 1.333 1.333 0 0 0 .819.281 1.349 1.349 0 0 0 .314-.037l9.263-2.2V7.786a1.319 1.319 0 0 0-.964-1.258z",
    fill: "#3d3fea"
  })));
};
/* harmony default export */ var others_pingcap_logo = (SvgOthersPingcapLogo);
;// CONCATENATED MODULE: ./src/pages/home/others/others-flink-logo.png
/* harmony default export */ var others_flink_logo = ({"src":"https://img1.tidb.net/_next/static/media/others-flink-logo.97e04cf6.png","height":774,"width":979,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAS1BMVEUsHhSQNkUrKx2mZHeBVoZWN04mKSoTJCR7R1NaOj63T2jEmmagSnAlKCm1TU6qZjkTISqkQVOtQ1tnNzOzhVeYV1nRTmrXSWbASmHlxrhkAAAAFHRSTlMBPS/4/h5lTJlL+q3sXPpDE4RxdNij9YoAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA1SURBVAiZFcVHEoAgEADBIS5JUZTw/5dS9KUB8h85gunhHK1NSwGujHlXcKi3ffrh8iJaxG8hTQFlyc2n9wAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/home/others/Others.component.js
function Others_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Others_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Others_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var Others = function() {
    var data = (0,react.useContext)(context/* PageDataContext */.A6).data;
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Container, {
        $isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
            title: "\u5176\u4ED6\u8D44\u6E90",
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(others_styled_ModuleTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: "\u89C6\u9891\u4E13\u533A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                href: "https://space.bilibili.com/86485707",
                                children: "\u67E5\u770B\u66F4\u591A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        gutter: 16,
                        children: data.videos.slice(0, isSmallScreen ? 3 : 6).map(function(video, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                md: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnail_component, Others_component_objectSpread({}, video, {
                                    $isSmallScreen: isSmallScreen
                                }))
                            }, idx);
                        })
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: "\u5BFB\u627E\u5546\u4E1A\u652F\u6301"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(others_pingcap_logo, {
                            height: 36
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallerText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallerLink, {
                                href: "/support",
                                children: "PingCAP"
                            }),
                            " ",
                            "\u662F\u4E1A\u754C\u9886\u5148\u7684\u4F01\u4E1A\u7EA7\u5F00\u6E90\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u4F01\u4E1A\uFF0C\u63D0\u4F9B\u5F00\u6E90\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u4EA7\u54C1 TiDB \u89E3\u51B3\u65B9\u6848\u4E0E\u54A8\u8BE2\u3001\u6280\u672F\u652F\u6301\u4E0E\u57F9\u8BAD\u8BA4\u8BC1\u7B49\u670D\u52A1\u3002"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: "\u5408\u4F5C\u793E\u533A"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                maxHeight: 64
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Others_component_objectSpread({}, others_flink_logo, {
                                width: 81,
                                height: 64,
                                alt: "flink logo"
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallerText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallerLink, {
                                href: "https://flink-learning.org.cn",
                                children: "Apache Flink"
                            }),
                            " ",
                            "\u662F\u4E00\u4E2A\u9488\u5BF9\u65E0\u754C\u548C\u6709\u754C\u6570\u636E\u6D41\u8FDB\u884C\u6709\u72B6\u6001\u8BA1\u7B97\u7684\u6846\u67B6\u4E0E\u5206\u5E03\u5F0F\u5904\u7406\u5F15\u64CE\uFF0C\u4EE5\u6570\u636E\u5E76\u884C\u548C\u6D41\u6C34\u7EBF\u65B9\u5F0F\u6267\u884C\u4EFB\u610F\u6D41\u6570\u636E\u7A0B\u5E8F\u3002Flink \u80FD\u5728\u6240\u6709\u5E38\u89C1\u96C6\u7FA4\u73AF\u5883\u4E2D\u8FD0\u884C\uFF0C\u5E76\u80FD\u4EE5\u5185\u5B58\u901F\u5EA6\u548C\u4EFB\u610F\u89C4\u6A21\u8FDB\u884C\u8BA1\u7B97\u3002"
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Others_component = (Others);

;// CONCATENATED MODULE: ./src/pages/home/others/index.js


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./packages/datasource/src/api/subscribe/index.js
var subscribe = __webpack_require__(19090);
// EXTERNAL MODULE: ./src/pages/home/subscription/subscription.styled.js + 1 modules
var subscription_styled = __webpack_require__(35560);
;// CONCATENATED MODULE: ./src/pages/home/subscription/Subscription.component.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









var schema = es/* object */.Ry().shape({
    email: es/* string */.Z_().email()
});
var Subscription = function() {
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    // validate and subscribe
    var subscribeEmail = function() {
        schema.isValid({
            email: email
        }).then(function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(valid) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (legalConfirmation) {
                                _ctx.next = 4;
                                break;
                            }
                            {
                                message/* default.warn */.ZP.warn("\u8BF7\u786E\u8BA4\u9690\u79C1\u6761\u6B3E");
                            }
                            _ctx.next = 17;
                            break;
                        case 4:
                            if (!valid) {
                                _ctx.next = 16;
                                break;
                            }
                            _ctx.prev = 5;
                            _ctx.next = 8;
                            return subscribe.addEmail(email);
                        case 8:
                            message/* default.success */.ZP.success("\u8BA2\u9605\u6210\u529F");
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](5);
                            // when API call returns an error
                            message/* default.error */.ZP.error(_ctx.t0.response.data.detail);
                        case 14:
                            _ctx.next = 17;
                            break;
                        case 16:
                            {
                                // when yup validation fails
                                message/* default.error */.ZP.error("\u8BF7\u8F93\u5165\u5408\u6CD5\u7684\u90AE\u4EF6\u5730\u5740");
                            }
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        5,
                        11
                    ]
                ]);
            }));
            return function(valid) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var checkLegal = function() {
        return setLegalConfirmation(!legalConfirmation);
    };
    var ref1 = (0,react.useState)(false), legalConfirmation = ref1[0], setLegalConfirmation = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* Container */.W2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* TwoColumns */.VZ, {
            isSmallScreen: isSmallScreen,
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(subscription_styled/* Slogan */.ne, {
                        children: [
                            "TiDB \u53CA\u5176\u751F\u6001\u9879\u76EE\u7531\u6765\u81EA\u5168\u7403\u5404\u5730\u7684 1400+ \u4F4D\u8D21\u732E\u8005\u5171\u540C\u5EFA\u8BBE\u4E0E\u7EF4\u62A4\uFF0C\u7531\u6B64\u67E5\u770B",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* Link */.rU, {
                                href: "https://github.com/pingcap/tidb/graphs/contributors",
                                children: "\u8D21\u732E\u8005\u5217\u8868"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                        href: "https://www.pingcap.cn/privacy-policy",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* ActionButton */.Kk, {
                            children: "\u9690\u79C1\u653F\u7B56"
                        })
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* Slogan */.ne, {
                        children: "\u8BA2\u9605 TiDB \u793E\u533A\u7684\u6700\u65B0\u8D44\u8BAF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* EmailInput */.U5, {
                        $submitDisabled: !legalConfirmation,
                        enterButton: "\u63D0\u4EA4",
                        onChange: function(e) {
                            return setEmail(e.target.value);
                        },
                        onSubmit: subscribeEmail,
                        placeholder: "\u7535\u5B50\u90AE\u7BB1\u5730\u5740"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(subscription_styled/* TermCaption */.ov, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* LegalCheckbox */.Hz, {
                                checked: legalConfirmation,
                                onChange: checkLegal
                            }),
                            "\u672C\u4EBA\u5DF2\u9605\u8BFB\u5E76\u540C\u610F TiDB Community \u7684",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* Link */.rU, {
                                href: "https://www.pingcap.cn/privacy-policy",
                                children: "\u9690\u79C1\u653F\u7B56"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Subscription_component = (Subscription);

;// CONCATENATED MODULE: ./src/pages/home/subscription/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/pages/home/welcome/welcome.styled.js
function welcome_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function welcome_styled_templateObject() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n        ",
        " {\n          &::after {\n            display: none;\n          }\n        }\n\n        ",
        " {\n          .ant-radio-button-wrapper {\n            padding: 0 1rem;\n          }\n        }\n      "
    ]);
    welcome_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject1() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n  && {\n    text-align: center;\n    padding: 5rem 0 0;\n    //background: ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    welcome_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject2() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n  && {\n    .ant-radio-button-wrapper {\n      ",
        ";\n      border-color: ",
        ";\n      padding: 0 2rem;\n\n      &:first-child {\n        border-left-color: ",
        ";\n        border-radius: 6px 0 0 6px;\n      }\n\n      &:last-child {\n        border-radius: 0 6px 6px 0;\n      }\n\n      &:hover {\n        color: ",
        ";\n        background: ",
        ";\n        border-color: ",
        ";\n\n        &:first-child {\n          border-left-color: ",
        ";\n        }\n\n        .ant-radio-button-wrapper-checked {\n          &::before {\n            background-color: ",
        ";\n          }\n        }\n      }\n    }\n\n    .ant-radio-button-wrapper-checked {\n      font-size: 16px;\n      color: ",
        ";\n\n      &::before {\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    welcome_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject3() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 36px;\n  line-height: 1.2;\n  position: relative;\n  z-index: 0;\n\n  &::after {\n    content: '';\n    display: block;\n    height: 12px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background: ",
        ";\n    opacity: 20%;\n    z-index: -1;\n  }\n"
    ]);
    welcome_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject4() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  font-size: 18px;\n  margin-bottom: 1rem;\n"
    ]);
    welcome_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject5() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n  margin: 3rem 0;\n\n  em {\n    font-size: 32px;\n    font-style: normal;\n    font-weight: bold;\n    color: ",
        ";\n  }\n\n  span {\n    display: block;\n    font-size: 18px;\n  }\n"
    ]);
    welcome_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject6() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n      height: 218px;\n      background: ",
        ";\n      ",
        " {\n        flex-direction: column;\n\n        h2,\n        ul,\n        li {\n          display: block;\n        }\n\n        h2,\n        ul {\n          padding: 0 1rem;\n        }\n\n        li {\n          margin: 0;\n          margin-top: 1rem;\n        }\n      }\n    "
    ]);
    welcome_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function welcome_styled_templateObject7() {
    var data = welcome_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  text-align: left;\n  color: ",
        ";\n  background: ",
        ";\n  background-size: cover;\n  height: 123px;\n\n  h2,\n  ul {\n    ",
        ";\n    color: ",
        " !important;\n    font-size: 18px;\n    font-weight: normal !important;\n  }\n\n  h2 {\n    display: inline-block;\n    margin-right: 4rem;\n  }\n\n  ul {\n    display: inline;\n    list-style: none;\n\n    li {\n      cursor: pointer;\n      margin-left: 3rem;\n      display: inline-block;\n      border-left: 7px solid ",
        ";\n      padding-left: 1rem;\n\n      &:first-child {\n        margin-left: 0;\n      }\n    }\n  }\n\n  ",
        ";\n"
    ]);
    welcome_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var welcome_styled_Content = styled/* Content */.VY, welcome_styled_Section = styled/* Section */.$0;

var welcome_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(welcome_styled_Section)(welcome_styled_templateObject1(), colors.M2, function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(welcome_styled_templateObject(), welcome_styled_Title, welcome_styled_Navs);
});
var welcome_styled_Navs = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default.Group */.ZP.Group)(welcome_styled_templateObject2(), mixins/* verticalLineMiddle */.XK("45px"), colors.T2, colors.T2, colors.M1, colors.B1, colors.B1, colors.B1, colors.B1, colors.F1, colors.T2);
var welcome_styled_Title = styled_components_browser_esm/* default.h2 */.ZP.h2(welcome_styled_templateObject3(), colors.B1);
var welcome_styled_Intro = styled_components_browser_esm/* default.p */.ZP.p(welcome_styled_templateObject4(), mixins/* reset */.mc());
var Numbers = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(welcome_styled_templateObject5(), colors.F1);
var HowTo = styled_components_browser_esm/* default.div */.ZP.div(welcome_styled_templateObject7(), mixins/* flexVerticalCenter */.VL(), colors.F1, colors.M2, mixins/* reset */.mc(), colors.F1, colors.B1, function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(welcome_styled_templateObject6(), colors.M2, welcome_styled_Content);
});

;// CONCATENATED MODULE: ./src/pages/home/welcome/welcome.utils.js
var formatNumber = function(num) {
    var maximumSignificantDigits;
    var len = (num + "").length;
    if (len === 4) {
        maximumSignificantDigits = 2;
    } else if (len > 4) {
        maximumSignificantDigits = len - 3;
    }
    return "".concat(new Intl.NumberFormat("en-US", {
        maximumSignificantDigits: maximumSignificantDigits
    }).format(num)).concat(maximumSignificantDigits ? "+" : "");
};

;// CONCATENATED MODULE: ./src/pages/home/welcome/Welcome.component.js








var Welcome = function() {
    var data = (0,react.useContext)(context/* PageDataContext */.A6).data;
    var ref = (0,useIsSmallScreen/* default */.Z)(), isSmallScreen = ref.isSmallScreen, breakpoint = ref.breakpoint;
    var githubInfo = data.githubInfo;
    var numbers = [
        {
            num: formatNumber(githubInfo.prNum),
            text: "Pull Requests"
        },
        {
            num: formatNumber(githubInfo.topicNum),
            text: "\u4E3B\u9898"
        },
        {
            num: formatNumber(githubInfo.postNum),
            text: "\u5E16\u5B50"
        },
        {
            num: formatNumber(githubInfo.contributorNum),
            text: "\u8D21\u732E\u8005"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(welcome_styled_Container, {
        isSmallScreen: isSmallScreen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_styled_Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    gutter: [
                        32,
                        32
                    ],
                    justify: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                        span: isSmallScreen ? 24 : 18,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_styled_Title, {
                                children: "Hi, \u6B22\u8FCE\u6765\u5230 TiDB \u793E\u533A!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_styled_Intro, {
                                children: "TiDB \u793E\u533A\u662F\u7531 TiDB \u751F\u6001\u4E2D\u7684\u5F00\u53D1\u8005\u3001\u7528\u6237\u3001Contributor\u3001\u5408\u4F5C\u4F19\u4F34\u4E00\u8D77\u5EFA\u7ACB\u7684\u5206\u4EAB\u3001\u5B66\u4E60\u5E73\u53F0\u3002\u5728\u8FD9\u91CC\uFF0C\u6211\u4EEC\u53EF\u4EE5\u81EA\u7531\u53D1\u58F0\uFF0C\u4E92\u76F8\u534F\u52A9\u89E3\u51B3\u95EE\u9898\u3002"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Numbers, {
                                gutter: 32,
                                justify: "center",
                                children: numbers.map(function(param, idx) {
                                    var num = param.num, text = param.text;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                        span: isSmallScreen ? 12 : 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: num
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: text
                                            })
                                        ]
                                    }, idx);
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowTo, {
                isSmallScreen: !breakpoint.lg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(welcome_styled_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "TiDB \u65B0\u624B\uFF1F\u70B9\u51FB\u5207\u6362\u63A2\u7D22\u8DEF\u5F84"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: "https://docs.pingcap.com/zh/tidb/stable/overview",
                                        children: "\u4EC0\u4E48\u662F TiDB \uFF1F"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: "#learning",
                                        children: "\u5982\u4F55\u4F7F\u7528 TiDB \uFF1F"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: "#contribution",
                                        children: "\u5982\u4F55\u8D21\u732E\u4EE3\u7801 \uFF1F"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Welcome_component = (Welcome);

;// CONCATENATED MODULE: ./src/pages/home/welcome/index.js


;// CONCATENATED MODULE: ./src/pages/home/index.tsx














var Page = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* PageDataContext.Provider */.A6.Provider, {
        value: {
            data: data
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u9996\u9875"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Welcome_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forum_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Blogs_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Activities_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Learning_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contribution_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Others_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscription_component, {})
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var home = (Page);

;// CONCATENATED MODULE: ./src/pages/index.page.tsx
var index_page_N_SSP = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5180,8422,5849,9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);